/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from "@tanstack/react-query";
import { useCoreContext, CoreContext } from "./coreContext";
import type * as Fetcher from "./coreFetcher";
import { coreFetch } from "./coreFetcher";
import type * as Schemas from "./coreSchemas";

export type GetAdvisorsError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorsResponse = Schemas.Advisor[];

export type GetAdvisorsVariables = CoreContext["fetcherOptions"];

export const fetchGetAdvisors = (
  variables: GetAdvisorsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<GetAdvisorsResponse, GetAdvisorsError, undefined, {}, {}, {}>({
    url: "/advisors",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAdvisors = <TData = GetAdvisorsResponse>(
  variables: GetAdvisorsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetAdvisorsResponse, GetAdvisorsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<GetAdvisorsResponse, GetAdvisorsError, TData>({
    queryKey: queryKeyFn({
      path: "/advisors",
      operationId: "getAdvisors",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisors({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PatchAdvisorPathParams = {
  advisorId: string;
};

export type PatchAdvisorError = Fetcher.ErrorWrapper<undefined>;

export type PatchAdvisorVariables = {
  body?: Schemas.AdvisorPatch;
  pathParams: PatchAdvisorPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPatchAdvisor = (
  variables: PatchAdvisorVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Advisor,
    PatchAdvisorError,
    Schemas.AdvisorPatch,
    {},
    {},
    PatchAdvisorPathParams
  >({ url: "/advisors/{advisorId}", method: "patch", ...variables, signal });

export const usePatchAdvisor = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Advisor,
      PatchAdvisorError,
      PatchAdvisorVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.Advisor,
    PatchAdvisorError,
    PatchAdvisorVariables
  >({
    mutationFn: (variables: PatchAdvisorVariables) =>
      fetchPatchAdvisor({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAdvisorMeetingsPathParams = {
  advisorId: string;
};

export type GetAdvisorMeetingsError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorMeetingsVariables = {
  pathParams: GetAdvisorMeetingsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAdvisorMeetings = (
  variables: GetAdvisorMeetingsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.AdvisorMeeting,
    GetAdvisorMeetingsError,
    undefined,
    {},
    {},
    GetAdvisorMeetingsPathParams
  >({
    url: "/advisors/{advisorId}/meetings",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAdvisorMeetings = <TData = Schemas.AdvisorMeeting>(
  variables: GetAdvisorMeetingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AdvisorMeeting,
      GetAdvisorMeetingsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.AdvisorMeeting,
    GetAdvisorMeetingsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisors/{advisorId}/meetings",
      operationId: "getAdvisorMeetings",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorMeetings({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetAircallRedirectQueryParams = {
  phoneNumber: string;
};

export type GetAircallRedirectError = Fetcher.ErrorWrapper<undefined>;

export type GetAircallRedirectVariables = {
  queryParams: GetAircallRedirectQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAircallRedirect = (
  variables: GetAircallRedirectVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    GetAircallRedirectError,
    undefined,
    {},
    GetAircallRedirectQueryParams,
    {}
  >({
    url: "/gateway/v1/aircall/redirect",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAircallRedirect = <TData = undefined>(
  variables: GetAircallRedirectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetAircallRedirectError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<undefined, GetAircallRedirectError, TData>({
    queryKey: queryKeyFn({
      path: "/gateway/v1/aircall/redirect",
      operationId: "getAircallRedirect",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAircallRedirect({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PostApplicationQueryParams = {
  /**
   * The lead ID of the customer, in case they had opted in before.
   */
  leadId?: string;
};

export type PostApplicationError = Fetcher.ErrorWrapper<undefined>;

export type PostApplicationVariables = {
  body: Schemas.Application;
  queryParams?: PostApplicationQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchPostApplication = (
  variables: PostApplicationVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Application,
    PostApplicationError,
    Schemas.Application,
    {},
    PostApplicationQueryParams,
    {}
  >({ url: "/gateway/v1/application", method: "post", ...variables, signal });

export const usePostApplication = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Application,
      PostApplicationError,
      PostApplicationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.Application,
    PostApplicationError,
    PostApplicationVariables
  >({
    mutationFn: (variables: PostApplicationVariables) =>
      fetchPostApplication({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetApplicationResultsPathParams = {
  /**
   * The UUID of the application
   */
  applicationId: string;
};

export type GetApplicationResultsError = Fetcher.ErrorWrapper<undefined>;

export type GetApplicationResultsVariables = {
  pathParams: GetApplicationResultsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetApplicationResults = (
  variables: GetApplicationResultsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Application,
    GetApplicationResultsError,
    undefined,
    {},
    {},
    GetApplicationResultsPathParams
  >({
    url: "/gateway/v1/application/{applicationId}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetApplicationResults = <TData = Schemas.Application>(
  variables: GetApplicationResultsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Application,
      GetApplicationResultsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.Application,
    GetApplicationResultsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/gateway/v1/application/{applicationId}",
      operationId: "getApplicationResults",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetApplicationResults({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetAdvisorCalendarPathParams = {
  applicationId: string;
};

export type GetAdvisorCalendarError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorCalendarVariables = {
  pathParams: GetAdvisorCalendarPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAdvisorCalendar = (
  variables: GetAdvisorCalendarVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    string,
    GetAdvisorCalendarError,
    undefined,
    {},
    {},
    GetAdvisorCalendarPathParams
  >({
    url: "/gateway/v1/applications/{applicationId}/advisor-calendar",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAdvisorCalendar = <TData = string>(
  variables: GetAdvisorCalendarVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<string, GetAdvisorCalendarError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<string, GetAdvisorCalendarError, TData>({
    queryKey: queryKeyFn({
      path: "/gateway/v1/applications/{applicationId}/advisor-calendar",
      operationId: "getAdvisorCalendar",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorCalendar({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetAssumptionsQueryParams = {
  /**
   * The federal state to retrieve the assumptions for. If not filled, the default federal state will be used.
   */
  federalState?: string;
  /**
   * The zip code to retrieve the assumptions for
   */
  zipCode?: string;
};

export type GetAssumptionsError = Fetcher.ErrorWrapper<undefined>;

export type GetAssumptionsVariables = {
  queryParams?: GetAssumptionsQueryParams;
} & CoreContext["fetcherOptions"];

/**
 * Retrieve all assumptions for the given parameters
 */
export const fetchGetAssumptions = (
  variables: GetAssumptionsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Assumptions,
    GetAssumptionsError,
    undefined,
    {},
    GetAssumptionsQueryParams,
    {}
  >({ url: "/gateway/v1/assumption", method: "get", ...variables, signal });

/**
 * Retrieve all assumptions for the given parameters
 */
export const useGetAssumptions = <TData = Schemas.Assumptions>(
  variables: GetAssumptionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Assumptions, GetAssumptionsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<Schemas.Assumptions, GetAssumptionsError, TData>({
    queryKey: queryKeyFn({
      path: "/gateway/v1/assumption",
      operationId: "getAssumptions",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAssumptions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PostCertificateError = Fetcher.ErrorWrapper<undefined>;

export type PostCertificateVariables = {
  body: Schemas.CertificateData;
} & CoreContext["fetcherOptions"];

/**
 * Request a certificate
 */
export const fetchPostCertificate = (
  variables: PostCertificateVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostCertificateError,
    Schemas.CertificateData,
    {},
    {},
    {}
  >({ url: "/gateway/v1/certificate", method: "post", ...variables, signal });

/**
 * Request a certificate
 */
export const usePostCertificate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostCertificateError,
      PostCertificateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostCertificateError,
    PostCertificateVariables
  >({
    mutationFn: (variables: PostCertificateVariables) =>
      fetchPostCertificate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetCertificateByTokenPathParams = {
  token: string;
};

export type GetCertificateByTokenError = Fetcher.ErrorWrapper<undefined>;

export type GetCertificateByTokenVariables = {
  pathParams: GetCertificateByTokenPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetCertificateByToken = (
  variables: GetCertificateByTokenVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    GetCertificateByTokenError,
    undefined,
    {},
    {},
    GetCertificateByTokenPathParams
  >({
    url: "/gateway/v1/certificate/{token}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetCertificateByToken = <TData = undefined>(
  variables: GetCertificateByTokenVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetCertificateByTokenError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<undefined, GetCertificateByTokenError, TData>({
    queryKey: queryKeyFn({
      path: "/gateway/v1/certificate/{token}",
      operationId: "getCertificateByToken",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetCertificateByToken({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateFrontendStateError = Fetcher.ErrorWrapper<undefined>;

export type CreateFrontendStateVariables = {
  body: Schemas.FrontendState;
} & CoreContext["fetcherOptions"];

export const fetchCreateFrontendState = (
  variables: CreateFrontendStateVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.FrontendState,
    CreateFrontendStateError,
    Schemas.FrontendState,
    {},
    {},
    {}
  >({
    url: "/gateway/v1/frontend-state",
    method: "post",
    ...variables,
    signal,
  });

export const useCreateFrontendState = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.FrontendState,
      CreateFrontendStateError,
      CreateFrontendStateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.FrontendState,
    CreateFrontendStateError,
    CreateFrontendStateVariables
  >({
    mutationFn: (variables: CreateFrontendStateVariables) =>
      fetchCreateFrontendState({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetFrontendStatePathParams = {
  id: string;
};

export type GetFrontendStateQueryParams = {
  token: string;
};

export type GetFrontendStateError = Fetcher.ErrorWrapper<undefined>;

export type GetFrontendStateVariables = {
  pathParams: GetFrontendStatePathParams;
  queryParams: GetFrontendStateQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchGetFrontendState = (
  variables: GetFrontendStateVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.FrontendState,
    GetFrontendStateError,
    undefined,
    {},
    GetFrontendStateQueryParams,
    GetFrontendStatePathParams
  >({
    url: "/gateway/v1/frontend-state/{id}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetFrontendState = <TData = Schemas.FrontendState>(
  variables: GetFrontendStateVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.FrontendState,
      GetFrontendStateError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.FrontendState,
    GetFrontendStateError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/gateway/v1/frontend-state/{id}",
      operationId: "getFrontendState",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetFrontendState({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type UpdateFrontendStatePathParams = {
  id: string;
};

export type UpdateFrontendStateError = Fetcher.ErrorWrapper<undefined>;

export type UpdateFrontendStateVariables = {
  body: Schemas.FrontendState;
  pathParams: UpdateFrontendStatePathParams;
} & CoreContext["fetcherOptions"];

export const fetchUpdateFrontendState = (
  variables: UpdateFrontendStateVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    UpdateFrontendStateError,
    Schemas.FrontendState,
    {},
    {},
    UpdateFrontendStatePathParams
  >({
    url: "/gateway/v1/frontend-state/{id}",
    method: "put",
    ...variables,
    signal,
  });

export const useUpdateFrontendState = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateFrontendStateError,
      UpdateFrontendStateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    UpdateFrontendStateError,
    UpdateFrontendStateVariables
  >({
    mutationFn: (variables: UpdateFrontendStateVariables) =>
      fetchUpdateFrontendState({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostLeadError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ErrorResponse;
}>;

export type PostLeadVariables = {
  body: Schemas.Lead;
} & CoreContext["fetcherOptions"];

/**
 * Create a lead
 */
export const fetchPostLead = (
  variables: PostLeadVariables,
  signal?: AbortSignal,
) =>
  coreFetch<Schemas.Lead, PostLeadError, Schemas.Lead, {}, {}, {}>({
    url: "/gateway/v1/lead",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Create a lead
 */
export const usePostLead = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Lead,
      PostLeadError,
      PostLeadVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<Schemas.Lead, PostLeadError, PostLeadVariables>(
    {
      mutationFn: (variables: PostLeadVariables) =>
        fetchPostLead({ ...fetcherOptions, ...variables }),
      ...options,
    },
  );
};

export type PostMeetingQualificationPathParams = {
  leadId: string;
};

export type PostMeetingQualificationError = Fetcher.ErrorWrapper<undefined>;

export type PostMeetingQualificationVariables = {
  body?: Schemas.MeetingQualification;
  pathParams: PostMeetingQualificationPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostMeetingQualification = (
  variables: PostMeetingQualificationVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostMeetingQualificationError,
    Schemas.MeetingQualification,
    {},
    {},
    PostMeetingQualificationPathParams
  >({
    url: "/gateway/v1/qualification-meeting/{leadId}",
    method: "post",
    ...variables,
    signal,
  });

export const usePostMeetingQualification = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostMeetingQualificationError,
      PostMeetingQualificationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostMeetingQualificationError,
    PostMeetingQualificationVariables
  >({
    mutationFn: (variables: PostMeetingQualificationVariables) =>
      fetchPostMeetingQualification({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ShareMedalRatingEmailQueryParams = {
  leadId?: string;
  hubspotDealId?: string;
};

export type ShareMedalRatingEmailError = Fetcher.ErrorWrapper<undefined>;

export type ShareMedalRatingEmailVariables = {
  queryParams?: ShareMedalRatingEmailQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchShareMedalRatingEmail = (
  variables: ShareMedalRatingEmailVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    ShareMedalRatingEmailError,
    undefined,
    {},
    ShareMedalRatingEmailQueryParams,
    {}
  >({
    url: "/gateway/v1/lead/share-medal-rating",
    method: "get",
    ...variables,
    signal,
  });

export const useShareMedalRatingEmail = <TData = undefined>(
  variables: ShareMedalRatingEmailVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, ShareMedalRatingEmailError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<undefined, ShareMedalRatingEmailError, TData>({
    queryKey: queryKeyFn({
      path: "/gateway/v1/lead/share-medal-rating",
      operationId: "shareMedalRatingEmail",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShareMedalRatingEmail({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PostLeadActionPathParams = {
  leadId: string;
};

export type PostLeadActionError = Fetcher.ErrorWrapper<undefined>;

export type PostLeadActionVariables = {
  body: Schemas.LeadAction;
  pathParams: PostLeadActionPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostLeadAction = (
  variables: PostLeadActionVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostLeadActionError,
    Schemas.LeadAction,
    {},
    {},
    PostLeadActionPathParams
  >({
    url: "/gateway/v1/lead/{leadId}/action",
    method: "post",
    ...variables,
    signal,
  });

export const usePostLeadAction = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostLeadActionError,
      PostLeadActionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostLeadActionError,
    PostLeadActionVariables
  >({
    mutationFn: (variables: PostLeadActionVariables) =>
      fetchPostLeadAction({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PutMedalRatingPathParams = {
  leadId: string;
};

export type PutMedalRatingQueryParams = {
  clientMode: Schemas.ClientMode;
  applicationId?: string;
  projectId?: string;
};

export type PutMedalRatingError = Fetcher.ErrorWrapper<undefined>;

export type PutMedalRatingVariables = {
  body: Schemas.MedalRatingBody;
  pathParams: PutMedalRatingPathParams;
  queryParams: PutMedalRatingQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchPutMedalRating = (
  variables: PutMedalRatingVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PutMedalRatingError,
    Schemas.MedalRatingBody,
    {},
    PutMedalRatingQueryParams,
    PutMedalRatingPathParams
  >({
    url: "/gateway/v1/lead/{leadId}/medal-rating",
    method: "put",
    ...variables,
    signal,
  });

export const usePutMedalRating = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PutMedalRatingError,
      PutMedalRatingVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PutMedalRatingError,
    PutMedalRatingVariables
  >({
    mutationFn: (variables: PutMedalRatingVariables) =>
      fetchPutMedalRating({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostMaximumBudgetError = Fetcher.ErrorWrapper<undefined>;

export type PostMaximumBudgetVariables = {
  body: Schemas.MaximumBudget;
} & CoreContext["fetcherOptions"];

export const fetchPostMaximumBudget = (
  variables: PostMaximumBudgetVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.MaximumBudget,
    PostMaximumBudgetError,
    Schemas.MaximumBudget,
    {},
    {},
    {}
  >({
    url: "/gateway/v1/maximum-budget",
    method: "post",
    ...variables,
    signal,
  });

export const usePostMaximumBudget = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MaximumBudget,
      PostMaximumBudgetError,
      PostMaximumBudgetVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.MaximumBudget,
    PostMaximumBudgetError,
    PostMaximumBudgetVariables
  >({
    mutationFn: (variables: PostMaximumBudgetVariables) =>
      fetchPostMaximumBudget({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetPartnerByOnofficeWebCustomerIdPathParams = {
  webCustomerId: string;
};

export type GetPartnerByOnofficeWebCustomerIdError =
  Fetcher.ErrorWrapper<undefined>;

export type GetPartnerByOnofficeWebCustomerIdVariables = {
  pathParams: GetPartnerByOnofficeWebCustomerIdPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetPartnerByOnofficeWebCustomerId = (
  variables: GetPartnerByOnofficeWebCustomerIdVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Partner,
    GetPartnerByOnofficeWebCustomerIdError,
    undefined,
    {},
    {},
    GetPartnerByOnofficeWebCustomerIdPathParams
  >({
    url: "/gateway/v1/partner/onoffice/{webCustomerId}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetPartnerByOnofficeWebCustomerId = <TData = Schemas.Partner>(
  variables: GetPartnerByOnofficeWebCustomerIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Partner,
      GetPartnerByOnofficeWebCustomerIdError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.Partner,
    GetPartnerByOnofficeWebCustomerIdError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/gateway/v1/partner/onoffice/{webCustomerId}",
      operationId: "getPartnerByOnofficeWebCustomerId",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetPartnerByOnofficeWebCustomerId(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type GetPartnerByPropstackCompanyIdPathParams = {
  companyId: number;
};

export type GetPartnerByPropstackCompanyIdError =
  Fetcher.ErrorWrapper<undefined>;

export type GetPartnerByPropstackCompanyIdVariables = {
  pathParams: GetPartnerByPropstackCompanyIdPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetPartnerByPropstackCompanyId = (
  variables: GetPartnerByPropstackCompanyIdVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Partner,
    GetPartnerByPropstackCompanyIdError,
    undefined,
    {},
    {},
    GetPartnerByPropstackCompanyIdPathParams
  >({
    url: "/gateway/v1/partner/propstack/{companyId}/",
    method: "get",
    ...variables,
    signal,
  });

export const useGetPartnerByPropstackCompanyId = <TData = Schemas.Partner>(
  variables: GetPartnerByPropstackCompanyIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Partner,
      GetPartnerByPropstackCompanyIdError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.Partner,
    GetPartnerByPropstackCompanyIdError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/gateway/v1/partner/propstack/{companyId}/",
      operationId: "getPartnerByPropstackCompanyId",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetPartnerByPropstackCompanyId(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type GetPartnerPathParams = {
  id: string;
};

export type GetPartnerQueryParams = {
  property?: Schemas.GetPartnerPropertyEnum;
};

export type GetPartnerError = Fetcher.ErrorWrapper<undefined>;

export type GetPartnerVariables = {
  pathParams: GetPartnerPathParams;
  queryParams?: GetPartnerQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchGetPartner = (
  variables: GetPartnerVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Partner,
    GetPartnerError,
    undefined,
    {},
    GetPartnerQueryParams,
    GetPartnerPathParams
  >({ url: "/gateway/v1/partner/{id}", method: "get", ...variables, signal });

export const useGetPartner = <TData = Schemas.Partner>(
  variables: GetPartnerVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Partner, GetPartnerError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<Schemas.Partner, GetPartnerError, TData>({
    queryKey: queryKeyFn({
      path: "/gateway/v1/partner/{id}",
      operationId: "getPartner",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetPartner({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PostPartnerApplicationPathParams = {
  partnerId: string;
};

export type PostPartnerApplicationQueryParams = {
  clientMode: Schemas.ClientMode;
};

export type PostPartnerApplicationError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ErrorResponse;
}>;

export type PostPartnerApplicationVariables = {
  body: Schemas.PartnerCRMApplication;
  pathParams: PostPartnerApplicationPathParams;
  queryParams: PostPartnerApplicationQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchPostPartnerApplication = (
  variables: PostPartnerApplicationVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Application,
    PostPartnerApplicationError,
    Schemas.PartnerCRMApplication,
    {},
    PostPartnerApplicationQueryParams,
    PostPartnerApplicationPathParams
  >({
    url: "/gateway/v1/partner/{partnerId}/application",
    method: "post",
    ...variables,
    signal,
  });

export const usePostPartnerApplication = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Application,
      PostPartnerApplicationError,
      PostPartnerApplicationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.Application,
    PostPartnerApplicationError,
    PostPartnerApplicationVariables
  >({
    mutationFn: (variables: PostPartnerApplicationVariables) =>
      fetchPostPartnerApplication({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostPartnerLeadPathParams = {
  partnerId: string;
};

export type PostPartnerLeadQueryParams = {
  clientMode: Schemas.ClientMode;
};

export type PostPartnerLeadError = Fetcher.ErrorWrapper<undefined>;

export type PostPartnerLeadVariables = {
  body: Schemas.PartnerCRMLead;
  pathParams: PostPartnerLeadPathParams;
  queryParams: PostPartnerLeadQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchPostPartnerLead = (
  variables: PostPartnerLeadVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Lead,
    PostPartnerLeadError,
    Schemas.PartnerCRMLead,
    {},
    PostPartnerLeadQueryParams,
    PostPartnerLeadPathParams
  >({
    url: "/gateway/v1/partner/{partnerId}/lead",
    method: "post",
    ...variables,
    signal,
  });

export const usePostPartnerLead = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Lead,
      PostPartnerLeadError,
      PostPartnerLeadVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.Lead,
    PostPartnerLeadError,
    PostPartnerLeadVariables
  >({
    mutationFn: (variables: PostPartnerLeadVariables) =>
      fetchPostPartnerLead({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetPartnerPropertyPathParams = {
  partnerId: string;
  propertyId: string;
};

export type GetPartnerPropertyQueryParams = {
  clientMode: Schemas.ClientMode;
};

export type GetPartnerPropertyError = Fetcher.ErrorWrapper<undefined>;

export type GetPartnerPropertyVariables = {
  pathParams: GetPartnerPropertyPathParams;
  queryParams: GetPartnerPropertyQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchGetPartnerProperty = (
  variables: GetPartnerPropertyVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.PartnerCRMProperty,
    GetPartnerPropertyError,
    undefined,
    {},
    GetPartnerPropertyQueryParams,
    GetPartnerPropertyPathParams
  >({
    url: "/gateway/v1/partner/{partnerId}/property/{propertyId}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetPartnerProperty = <TData = Schemas.PartnerCRMProperty>(
  variables: GetPartnerPropertyVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PartnerCRMProperty,
      GetPartnerPropertyError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.PartnerCRMProperty,
    GetPartnerPropertyError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/gateway/v1/partner/{partnerId}/property/{propertyId}",
      operationId: "getPartnerProperty",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetPartnerProperty({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type SearchPlacesError = Fetcher.ErrorWrapper<undefined>;

export type SearchPlacesResponse = Schemas.Place[];

export type SearchPlacesVariables = {
  body: Schemas.SearchPlace;
} & CoreContext["fetcherOptions"];

export const fetchSearchPlaces = (
  variables: SearchPlacesVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    SearchPlacesResponse,
    SearchPlacesError,
    Schemas.SearchPlace,
    {},
    {},
    {}
  >({ url: "/gateway/v1/places", method: "post", ...variables, signal });

export const useSearchPlaces = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      SearchPlacesResponse,
      SearchPlacesError,
      SearchPlacesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    SearchPlacesResponse,
    SearchPlacesError,
    SearchPlacesVariables
  >({
    mutationFn: (variables: SearchPlacesVariables) =>
      fetchSearchPlaces({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SaveFirstMeetingNpsPathParams = {
  projectId: string;
};

export type SaveFirstMeetingNpsQueryParams = {
  advisorId: string;
  rt: number;
};

export type SaveFirstMeetingNpsError = Fetcher.ErrorWrapper<undefined>;

export type SaveFirstMeetingNpsVariables = {
  pathParams: SaveFirstMeetingNpsPathParams;
  queryParams: SaveFirstMeetingNpsQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchSaveFirstMeetingNps = (
  variables: SaveFirstMeetingNpsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    SaveFirstMeetingNpsError,
    undefined,
    {},
    SaveFirstMeetingNpsQueryParams,
    SaveFirstMeetingNpsPathParams
  >({
    url: "/gateway/v1/projects/{projectId}/meeting-nps",
    method: "get",
    ...variables,
    signal,
  });

export const useSaveFirstMeetingNps = <TData = undefined>(
  variables: SaveFirstMeetingNpsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SaveFirstMeetingNpsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<undefined, SaveFirstMeetingNpsError, TData>({
    queryKey: queryKeyFn({
      path: "/gateway/v1/projects/{projectId}/meeting-nps",
      operationId: "saveFirstMeetingNps",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchSaveFirstMeetingNps({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetSavedOffersPdfByTokenPathParams = {
  token: string;
};

export type GetSavedOffersPdfByTokenError = Fetcher.ErrorWrapper<undefined>;

export type GetSavedOffersPdfByTokenVariables = {
  pathParams: GetSavedOffersPdfByTokenPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetSavedOffersPdfByToken = (
  variables: GetSavedOffersPdfByTokenVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    GetSavedOffersPdfByTokenError,
    undefined,
    {},
    {},
    GetSavedOffersPdfByTokenPathParams
  >({
    url: "/gateway/v1/saved-offers-pdf/{token}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetSavedOffersPdfByToken = <TData = undefined>(
  variables: GetSavedOffersPdfByTokenVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetSavedOffersPdfByTokenError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<undefined, GetSavedOffersPdfByTokenError, TData>({
    queryKey: queryKeyFn({
      path: "/gateway/v1/saved-offers-pdf/{token}",
      operationId: "getSavedOffersPdfByToken",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetSavedOffersPdfByToken(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type PostSubscriptionError = Fetcher.ErrorWrapper<undefined>;

export type PostSubscriptionVariables = {
  body: Schemas.Subscription;
} & CoreContext["fetcherOptions"];

export const fetchPostSubscription = (
  variables: PostSubscriptionVariables,
  signal?: AbortSignal,
) =>
  coreFetch<undefined, PostSubscriptionError, Schemas.Subscription, {}, {}, {}>(
    { url: "/gateway/v1/subscription", method: "post", ...variables, signal },
  );

export const usePostSubscription = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostSubscriptionError,
      PostSubscriptionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostSubscriptionError,
    PostSubscriptionVariables
  >({
    mutationFn: (variables: PostSubscriptionVariables) =>
      fetchPostSubscription({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetInterestRateChartQueryParams = {
  period?: string;
};

export type GetInterestRateChartHeaders = {
  Authorization: string;
};

export type GetInterestRateChartError = Fetcher.ErrorWrapper<undefined>;

export type GetInterestRateChartResponse = Schemas.InterestRate[];

export type GetInterestRateChartVariables = {
  headers: GetInterestRateChartHeaders;
  queryParams?: GetInterestRateChartQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchGetInterestRateChart = (
  variables: GetInterestRateChartVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetInterestRateChartResponse,
    GetInterestRateChartError,
    undefined,
    GetInterestRateChartHeaders,
    GetInterestRateChartQueryParams,
    {}
  >({ url: "/interest-rates", method: "get", ...variables, signal });

export const useGetInterestRateChart = <TData = GetInterestRateChartResponse>(
  variables: GetInterestRateChartVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetInterestRateChartResponse,
      GetInterestRateChartError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    GetInterestRateChartResponse,
    GetInterestRateChartError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/interest-rates",
      operationId: "getInterestRateChart",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetInterestRateChart({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PostOnofficeApiTokenError = Fetcher.ErrorWrapper<undefined>;

export type PostOnofficeApiTokenVariables = {
  body: Schemas.OnOfficeApiToken;
} & CoreContext["fetcherOptions"];

export const fetchPostOnofficeApiToken = (
  variables: PostOnofficeApiTokenVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostOnofficeApiTokenError,
    Schemas.OnOfficeApiToken,
    {},
    {},
    {}
  >({ url: "/partner/onoffice/api-key", method: "post", ...variables, signal });

export const usePostOnofficeApiToken = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostOnofficeApiTokenError,
      PostOnofficeApiTokenVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostOnofficeApiTokenError,
    PostOnofficeApiTokenVariables
  >({
    mutationFn: (variables: PostOnofficeApiTokenVariables) =>
      fetchPostOnofficeApiToken({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostMigrateMaximumBudgetPathParams = {
  partnerId: string;
};

export type PostMigrateMaximumBudgetError = Fetcher.ErrorWrapper<undefined>;

export type PostMigrateMaximumBudgetVariables = {
  pathParams: PostMigrateMaximumBudgetPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostMigrateMaximumBudget = (
  variables: PostMigrateMaximumBudgetVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostMigrateMaximumBudgetError,
    undefined,
    {},
    {},
    PostMigrateMaximumBudgetPathParams
  >({
    url: "/partners/{partnerId}/migrate-maximum-budget",
    method: "post",
    ...variables,
    signal,
  });

export const usePostMigrateMaximumBudget = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostMigrateMaximumBudgetError,
      PostMigrateMaximumBudgetVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostMigrateMaximumBudgetError,
    PostMigrateMaximumBudgetVariables
  >({
    mutationFn: (variables: PostMigrateMaximumBudgetVariables) =>
      fetchPostMigrateMaximumBudget({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostPartnerStatsPathParams = {
  partnerId: string;
};

export type PostPartnerStatsError = Fetcher.ErrorWrapper<undefined>;

export type PostPartnerStatsVariables = {
  pathParams: PostPartnerStatsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostPartnerStats = (
  variables: PostPartnerStatsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostPartnerStatsError,
    undefined,
    {},
    {},
    PostPartnerStatsPathParams
  >({
    url: "/partners/{partnerId}/stats",
    method: "post",
    ...variables,
    signal,
  });

export const usePostPartnerStats = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostPartnerStatsError,
      PostPartnerStatsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostPartnerStatsError,
    PostPartnerStatsVariables
  >({
    mutationFn: (variables: PostPartnerStatsVariables) =>
      fetchPostPartnerStats({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAdvisorError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorVariables = CoreContext["fetcherOptions"];

export const fetchGetAdvisor = (
  variables: GetAdvisorVariables,
  signal?: AbortSignal,
) =>
  coreFetch<Schemas.Advisor, GetAdvisorError, undefined, {}, {}, {}>({
    url: "/advisor/me",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAdvisor = <TData = Schemas.Advisor>(
  variables: GetAdvisorVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Advisor, GetAdvisorError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<Schemas.Advisor, GetAdvisorError, TData>({
    queryKey: queryKeyFn({
      path: "/advisor/me",
      operationId: "getAdvisor",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisor({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type AdvisorDownloadPartnerDocumentListPathParams = {
  leadId: string;
  projectId: string;
};

export type AdvisorDownloadPartnerDocumentListError =
  Fetcher.ErrorWrapper<undefined>;

export type AdvisorDownloadPartnerDocumentListVariables = {
  body: Schemas.DownloadPartnerDocumentListRequest;
  pathParams: AdvisorDownloadPartnerDocumentListPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorDownloadPartnerDocumentList = (
  variables: AdvisorDownloadPartnerDocumentListVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorDownloadPartnerDocumentListError,
    Schemas.DownloadPartnerDocumentListRequest,
    {},
    {},
    AdvisorDownloadPartnerDocumentListPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/download-partner-document-list",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorDownloadPartnerDocumentList = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorDownloadPartnerDocumentListError,
      AdvisorDownloadPartnerDocumentListVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorDownloadPartnerDocumentListError,
    AdvisorDownloadPartnerDocumentListVariables
  >({
    mutationFn: (variables: AdvisorDownloadPartnerDocumentListVariables) =>
      fetchAdvisorDownloadPartnerDocumentList({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type AdvisorChangeDocumentError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorChangeDocumentVariables = {
  body: Schemas.ChangeDocument;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorChangeDocument = (
  variables: AdvisorChangeDocumentVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorChangeDocumentError,
    Schemas.ChangeDocument,
    {},
    {},
    {}
  >({ url: "/advisor/change-document", method: "post", ...variables, signal });

export const useAdvisorChangeDocument = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorChangeDocumentError,
      AdvisorChangeDocumentVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorChangeDocumentError,
    AdvisorChangeDocumentVariables
  >({
    mutationFn: (variables: AdvisorChangeDocumentVariables) =>
      fetchAdvisorChangeDocument({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorChangePageDocumentError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorChangePageDocumentVariables = {
  body?: Schemas.ChangePageDocument;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorChangePageDocument = (
  variables: AdvisorChangePageDocumentVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorChangePageDocumentError,
    Schemas.ChangePageDocument,
    {},
    {},
    {}
  >({
    url: "/advisor/change-page-document",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorChangePageDocument = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorChangePageDocumentError,
      AdvisorChangePageDocumentVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorChangePageDocumentError,
    AdvisorChangePageDocumentVariables
  >({
    mutationFn: (variables: AdvisorChangePageDocumentVariables) =>
      fetchAdvisorChangePageDocument({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorDeleteCommentPathParams = {
  commentId: string;
};

export type AdvisorDeleteCommentError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorDeleteCommentVariables = {
  pathParams: AdvisorDeleteCommentPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorDeleteComment = (
  variables: AdvisorDeleteCommentVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorDeleteCommentError,
    undefined,
    {},
    {},
    AdvisorDeleteCommentPathParams
  >({
    url: "/advisor/comments/{commentId}",
    method: "delete",
    ...variables,
    signal,
  });

export const useAdvisorDeleteComment = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorDeleteCommentError,
      AdvisorDeleteCommentVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorDeleteCommentError,
    AdvisorDeleteCommentVariables
  >({
    mutationFn: (variables: AdvisorDeleteCommentVariables) =>
      fetchAdvisorDeleteComment({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorUpdateCommentPathParams = {
  commentId: string;
};

export type AdvisorUpdateCommentError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorUpdateCommentVariables = {
  body?: Schemas.DocumentPageCommentPatch;
  pathParams: AdvisorUpdateCommentPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorUpdateComment = (
  variables: AdvisorUpdateCommentVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorUpdateCommentError,
    Schemas.DocumentPageCommentPatch,
    {},
    {},
    AdvisorUpdateCommentPathParams
  >({
    url: "/advisor/comments/{commentId}",
    method: "patch",
    ...variables,
    signal,
  });

export const useAdvisorUpdateComment = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorUpdateCommentError,
      AdvisorUpdateCommentVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorUpdateCommentError,
    AdvisorUpdateCommentVariables
  >({
    mutationFn: (variables: AdvisorUpdateCommentVariables) =>
      fetchAdvisorUpdateComment({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateAdvisorDocumentPathParams = {
  documentGroupId: string;
};

export type CreateAdvisorDocumentError = Fetcher.ErrorWrapper<undefined>;

export type CreateAdvisorDocumentVariables = {
  body: Schemas.Document;
  pathParams: CreateAdvisorDocumentPathParams;
} & CoreContext["fetcherOptions"];

export const fetchCreateAdvisorDocument = (
  variables: CreateAdvisorDocumentVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Document,
    CreateAdvisorDocumentError,
    Schemas.Document,
    {},
    {},
    CreateAdvisorDocumentPathParams
  >({
    url: "/advisor/document-groups/{documentGroupId}/documents",
    method: "post",
    ...variables,
    signal,
  });

export const useCreateAdvisorDocument = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Document,
      CreateAdvisorDocumentError,
      CreateAdvisorDocumentVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.Document,
    CreateAdvisorDocumentError,
    CreateAdvisorDocumentVariables
  >({
    mutationFn: (variables: CreateAdvisorDocumentVariables) =>
      fetchCreateAdvisorDocument({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteAdvisorDocumentPathParams = {
  documentGroupId: string;
  documentId: string;
};

export type DeleteAdvisorDocumentQueryParams = {
  futureIgnore?: boolean;
};

export type DeleteAdvisorDocumentError = Fetcher.ErrorWrapper<undefined>;

export type DeleteAdvisorDocumentVariables = {
  pathParams: DeleteAdvisorDocumentPathParams;
  queryParams?: DeleteAdvisorDocumentQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchDeleteAdvisorDocument = (
  variables: DeleteAdvisorDocumentVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    DeleteAdvisorDocumentError,
    undefined,
    {},
    DeleteAdvisorDocumentQueryParams,
    DeleteAdvisorDocumentPathParams
  >({
    url: "/advisor/document-groups/{documentGroupId}/documents/{documentId}",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteAdvisorDocument = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteAdvisorDocumentError,
      DeleteAdvisorDocumentVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    DeleteAdvisorDocumentError,
    DeleteAdvisorDocumentVariables
  >({
    mutationFn: (variables: DeleteAdvisorDocumentVariables) =>
      fetchDeleteAdvisorDocument({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateAdvisorDocumentPathParams = {
  documentGroupId: string;
  documentId: string;
};

export type UpdateAdvisorDocumentError = Fetcher.ErrorWrapper<undefined>;

export type UpdateAdvisorDocumentVariables = {
  body: Schemas.Document;
  pathParams: UpdateAdvisorDocumentPathParams;
} & CoreContext["fetcherOptions"];

export const fetchUpdateAdvisorDocument = (
  variables: UpdateAdvisorDocumentVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Document,
    UpdateAdvisorDocumentError,
    Schemas.Document,
    {},
    {},
    UpdateAdvisorDocumentPathParams
  >({
    url: "/advisor/document-groups/{documentGroupId}/documents/{documentId}",
    method: "patch",
    ...variables,
    signal,
  });

export const useUpdateAdvisorDocument = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Document,
      UpdateAdvisorDocumentError,
      UpdateAdvisorDocumentVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.Document,
    UpdateAdvisorDocumentError,
    UpdateAdvisorDocumentVariables
  >({
    mutationFn: (variables: UpdateAdvisorDocumentVariables) =>
      fetchUpdateAdvisorDocument({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorDocumentApprovalPathParams = {
  documentGroupId: string;
  documentId: string;
};

export type AdvisorDocumentApprovalError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorDocumentApprovalVariables = {
  body: Schemas.Approval;
  pathParams: AdvisorDocumentApprovalPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorDocumentApproval = (
  variables: AdvisorDocumentApprovalVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorDocumentApprovalError,
    Schemas.Approval,
    {},
    {},
    AdvisorDocumentApprovalPathParams
  >({
    url: "/advisor/document-groups/{documentGroupId}/documents/{documentId}/approval",
    method: "patch",
    ...variables,
    signal,
  });

export const useAdvisorDocumentApproval = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorDocumentApprovalError,
      AdvisorDocumentApprovalVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorDocumentApprovalError,
    AdvisorDocumentApprovalVariables
  >({
    mutationFn: (variables: AdvisorDocumentApprovalVariables) =>
      fetchAdvisorDocumentApproval({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorPageApprovalPathParams = {
  documentGroupId: string;
  documentId: string;
  pageId: string;
};

export type AdvisorPageApprovalError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorPageApprovalVariables = {
  body: Schemas.Approval;
  pathParams: AdvisorPageApprovalPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorPageApproval = (
  variables: AdvisorPageApprovalVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorPageApprovalError,
    Schemas.Approval,
    {},
    {},
    AdvisorPageApprovalPathParams
  >({
    url: "/advisor/document-groups/{documentGroupId}/documents/{documentId}/approval/{pageId}",
    method: "patch",
    ...variables,
    signal,
  });

export const useAdvisorPageApproval = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorPageApprovalError,
      AdvisorPageApprovalVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorPageApprovalError,
    AdvisorPageApprovalVariables
  >({
    mutationFn: (variables: AdvisorPageApprovalVariables) =>
      fetchAdvisorPageApproval({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorAutoUpdateFieldsPathParams = {
  documentGroupId: string;
  documentId: string;
};

export type AdvisorAutoUpdateFieldsError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorAutoUpdateFieldsVariables = {
  pathParams: AdvisorAutoUpdateFieldsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorAutoUpdateFields = (
  variables: AdvisorAutoUpdateFieldsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.AutoUpdateFieldsResponse,
    AdvisorAutoUpdateFieldsError,
    undefined,
    {},
    {},
    AdvisorAutoUpdateFieldsPathParams
  >({
    url: "/advisor/document-groups/{documentGroupId}/documents/{documentId}/auto-update-fields",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorAutoUpdateFields = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AutoUpdateFieldsResponse,
      AdvisorAutoUpdateFieldsError,
      AdvisorAutoUpdateFieldsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.AutoUpdateFieldsResponse,
    AdvisorAutoUpdateFieldsError,
    AdvisorAutoUpdateFieldsVariables
  >({
    mutationFn: (variables: AdvisorAutoUpdateFieldsVariables) =>
      fetchAdvisorAutoUpdateFields({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateAdvisorPagePathParams = {
  documentGroupId: string;
  documentId: string;
  pageId: string;
};

export type UpdateAdvisorPageError = Fetcher.ErrorWrapper<undefined>;

export type UpdateAdvisorPageVariables = {
  body?: Schemas.PagePatch;
  pathParams: UpdateAdvisorPagePathParams;
} & CoreContext["fetcherOptions"];

export const fetchUpdateAdvisorPage = (
  variables: UpdateAdvisorPageVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    UpdateAdvisorPageError,
    Schemas.PagePatch,
    {},
    {},
    UpdateAdvisorPagePathParams
  >({
    url: "/advisor/document-groups/{documentGroupId}/documents/{documentId}/pages/{pageId}",
    method: "patch",
    ...variables,
    signal,
  });

export const useUpdateAdvisorPage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateAdvisorPageError,
      UpdateAdvisorPageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    UpdateAdvisorPageError,
    UpdateAdvisorPageVariables
  >({
    mutationFn: (variables: UpdateAdvisorPageVariables) =>
      fetchUpdateAdvisorPage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAdvisorDocumentListPresetsError =
  Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorDocumentListPresetsResponse =
  Schemas.DocumentListPreset[];

export type GetAdvisorDocumentListPresetsVariables =
  CoreContext["fetcherOptions"];

export const fetchGetAdvisorDocumentListPresets = (
  variables: GetAdvisorDocumentListPresetsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetAdvisorDocumentListPresetsResponse,
    GetAdvisorDocumentListPresetsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/advisor/document-list-presets",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAdvisorDocumentListPresets = <
  TData = GetAdvisorDocumentListPresetsResponse,
>(
  variables: GetAdvisorDocumentListPresetsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetAdvisorDocumentListPresetsResponse,
      GetAdvisorDocumentListPresetsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    GetAdvisorDocumentListPresetsResponse,
    GetAdvisorDocumentListPresetsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisor/document-list-presets",
      operationId: "getAdvisorDocumentListPresets",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorDocumentListPresets(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type CreateAdvisorDocumentListPresetError =
  Fetcher.ErrorWrapper<undefined>;

export type CreateAdvisorDocumentListPresetVariables = {
  body: Schemas.DocumentListPreset;
} & CoreContext["fetcherOptions"];

export const fetchCreateAdvisorDocumentListPreset = (
  variables: CreateAdvisorDocumentListPresetVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    CreateAdvisorDocumentListPresetError,
    Schemas.DocumentListPreset,
    {},
    {},
    {}
  >({
    url: "/advisor/document-list-presets",
    method: "post",
    ...variables,
    signal,
  });

export const useCreateAdvisorDocumentListPreset = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      CreateAdvisorDocumentListPresetError,
      CreateAdvisorDocumentListPresetVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    CreateAdvisorDocumentListPresetError,
    CreateAdvisorDocumentListPresetVariables
  >({
    mutationFn: (variables: CreateAdvisorDocumentListPresetVariables) =>
      fetchCreateAdvisorDocumentListPreset({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAdvisorDocumentListPresetPathParams = {
  documentListPresetId: string;
};

export type GetAdvisorDocumentListPresetError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorDocumentListPresetVariables = {
  pathParams: GetAdvisorDocumentListPresetPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAdvisorDocumentListPreset = (
  variables: GetAdvisorDocumentListPresetVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.DocumentListPreset,
    GetAdvisorDocumentListPresetError,
    undefined,
    {},
    {},
    GetAdvisorDocumentListPresetPathParams
  >({
    url: "/advisor/document-list-presets/{documentListPresetId}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAdvisorDocumentListPreset = <
  TData = Schemas.DocumentListPreset,
>(
  variables: GetAdvisorDocumentListPresetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DocumentListPreset,
      GetAdvisorDocumentListPresetError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.DocumentListPreset,
    GetAdvisorDocumentListPresetError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisor/document-list-presets/{documentListPresetId}",
      operationId: "getAdvisorDocumentListPreset",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorDocumentListPreset(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type DeleteAdvisorDocumentListPresetPathParams = {
  documentListPresetId: string;
};

export type DeleteAdvisorDocumentListPresetError =
  Fetcher.ErrorWrapper<undefined>;

export type DeleteAdvisorDocumentListPresetVariables = {
  pathParams: DeleteAdvisorDocumentListPresetPathParams;
} & CoreContext["fetcherOptions"];

export const fetchDeleteAdvisorDocumentListPreset = (
  variables: DeleteAdvisorDocumentListPresetVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    DeleteAdvisorDocumentListPresetError,
    undefined,
    {},
    {},
    DeleteAdvisorDocumentListPresetPathParams
  >({
    url: "/advisor/document-list-presets/{documentListPresetId}",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteAdvisorDocumentListPreset = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteAdvisorDocumentListPresetError,
      DeleteAdvisorDocumentListPresetVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    DeleteAdvisorDocumentListPresetError,
    DeleteAdvisorDocumentListPresetVariables
  >({
    mutationFn: (variables: DeleteAdvisorDocumentListPresetVariables) =>
      fetchDeleteAdvisorDocumentListPreset({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PatchAdvisorDocumentListPresetPathParams = {
  documentListPresetId: string;
};

export type PatchAdvisorDocumentListPresetError =
  Fetcher.ErrorWrapper<undefined>;

export type PatchAdvisorDocumentListPresetVariables = {
  body: Schemas.DocumentListPreset;
  pathParams: PatchAdvisorDocumentListPresetPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPatchAdvisorDocumentListPreset = (
  variables: PatchAdvisorDocumentListPresetVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.DocumentListPreset,
    PatchAdvisorDocumentListPresetError,
    Schemas.DocumentListPreset,
    {},
    {},
    PatchAdvisorDocumentListPresetPathParams
  >({
    url: "/advisor/document-list-presets/{documentListPresetId}",
    method: "patch",
    ...variables,
    signal,
  });

export const usePatchAdvisorDocumentListPreset = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DocumentListPreset,
      PatchAdvisorDocumentListPresetError,
      PatchAdvisorDocumentListPresetVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.DocumentListPreset,
    PatchAdvisorDocumentListPresetError,
    PatchAdvisorDocumentListPresetVariables
  >({
    mutationFn: (variables: PatchAdvisorDocumentListPresetVariables) =>
      fetchPatchAdvisorDocumentListPreset({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAdvisorDocumentTypesError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorDocumentTypesResponse = Schemas.DocumentType[];

export type GetAdvisorDocumentTypesVariables = CoreContext["fetcherOptions"];

export const fetchGetAdvisorDocumentTypes = (
  variables: GetAdvisorDocumentTypesVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetAdvisorDocumentTypesResponse,
    GetAdvisorDocumentTypesError,
    undefined,
    {},
    {},
    {}
  >({ url: "/advisor/document-types", method: "get", ...variables, signal });

export const useGetAdvisorDocumentTypes = <
  TData = GetAdvisorDocumentTypesResponse,
>(
  variables: GetAdvisorDocumentTypesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetAdvisorDocumentTypesResponse,
      GetAdvisorDocumentTypesError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    GetAdvisorDocumentTypesResponse,
    GetAdvisorDocumentTypesError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisor/document-types",
      operationId: "getAdvisorDocumentTypes",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorDocumentTypes({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateAdvisorDocumentTypeError = Fetcher.ErrorWrapper<undefined>;

export type CreateAdvisorDocumentTypeVariables = {
  body: Schemas.DocumentType;
} & CoreContext["fetcherOptions"];

export const fetchCreateAdvisorDocumentType = (
  variables: CreateAdvisorDocumentTypeVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.DocumentType,
    CreateAdvisorDocumentTypeError,
    Schemas.DocumentType,
    {},
    {},
    {}
  >({ url: "/advisor/document-types", method: "post", ...variables, signal });

export const useCreateAdvisorDocumentType = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DocumentType,
      CreateAdvisorDocumentTypeError,
      CreateAdvisorDocumentTypeVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.DocumentType,
    CreateAdvisorDocumentTypeError,
    CreateAdvisorDocumentTypeVariables
  >({
    mutationFn: (variables: CreateAdvisorDocumentTypeVariables) =>
      fetchCreateAdvisorDocumentType({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteAdvisorDocumentTypePathParams = {
  documentTypeId: string;
};

export type DeleteAdvisorDocumentTypeError = Fetcher.ErrorWrapper<undefined>;

export type DeleteAdvisorDocumentTypeVariables = {
  pathParams: DeleteAdvisorDocumentTypePathParams;
} & CoreContext["fetcherOptions"];

export const fetchDeleteAdvisorDocumentType = (
  variables: DeleteAdvisorDocumentTypeVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    DeleteAdvisorDocumentTypeError,
    undefined,
    {},
    {},
    DeleteAdvisorDocumentTypePathParams
  >({
    url: "/advisor/document-types/{documentTypeId}",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteAdvisorDocumentType = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteAdvisorDocumentTypeError,
      DeleteAdvisorDocumentTypeVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    DeleteAdvisorDocumentTypeError,
    DeleteAdvisorDocumentTypeVariables
  >({
    mutationFn: (variables: DeleteAdvisorDocumentTypeVariables) =>
      fetchDeleteAdvisorDocumentType({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PatchAdvisorDocumentTypePathParams = {
  documentTypeId: string;
};

export type PatchAdvisorDocumentTypeError = Fetcher.ErrorWrapper<undefined>;

export type PatchAdvisorDocumentTypeVariables = {
  body: Schemas.DocumentType;
  pathParams: PatchAdvisorDocumentTypePathParams;
} & CoreContext["fetcherOptions"];

export const fetchPatchAdvisorDocumentType = (
  variables: PatchAdvisorDocumentTypeVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.DocumentType,
    PatchAdvisorDocumentTypeError,
    Schemas.DocumentType,
    {},
    {},
    PatchAdvisorDocumentTypePathParams
  >({
    url: "/advisor/document-types/{documentTypeId}",
    method: "patch",
    ...variables,
    signal,
  });

export const usePatchAdvisorDocumentType = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DocumentType,
      PatchAdvisorDocumentTypeError,
      PatchAdvisorDocumentTypeVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.DocumentType,
    PatchAdvisorDocumentTypeError,
    PatchAdvisorDocumentTypeVariables
  >({
    mutationFn: (variables: PatchAdvisorDocumentTypeVariables) =>
      fetchPatchAdvisorDocumentType({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateAdvisorDocumentsError = Fetcher.ErrorWrapper<undefined>;

export type UpdateAdvisorDocumentsRequestBody = Schemas.Document[];

export type UpdateAdvisorDocumentsVariables = {
  body?: UpdateAdvisorDocumentsRequestBody;
} & CoreContext["fetcherOptions"];

export const fetchUpdateAdvisorDocuments = (
  variables: UpdateAdvisorDocumentsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    UpdateAdvisorDocumentsError,
    UpdateAdvisorDocumentsRequestBody,
    {},
    {},
    {}
  >({ url: "/advisor/documents", method: "patch", ...variables, signal });

export const useUpdateAdvisorDocuments = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateAdvisorDocumentsError,
      UpdateAdvisorDocumentsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    UpdateAdvisorDocumentsError,
    UpdateAdvisorDocumentsVariables
  >({
    mutationFn: (variables: UpdateAdvisorDocumentsVariables) =>
      fetchUpdateAdvisorDocuments({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorImportDocumentListsPathParams = {
  europaceCaseId: string;
};

export type AdvisorImportDocumentListsError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorImportDocumentListsRequestBody =
  Schemas.UnknownDocumentGroup[];

export type AdvisorImportDocumentListsVariables = {
  body?: AdvisorImportDocumentListsRequestBody;
  pathParams: AdvisorImportDocumentListsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorImportDocumentLists = (
  variables: AdvisorImportDocumentListsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorImportDocumentListsError,
    AdvisorImportDocumentListsRequestBody,
    {},
    {},
    AdvisorImportDocumentListsPathParams
  >({
    url: "/advisor/europace/{europaceCaseId}/import-document-lists",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorImportDocumentLists = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorImportDocumentListsError,
      AdvisorImportDocumentListsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorImportDocumentListsError,
    AdvisorImportDocumentListsVariables
  >({
    mutationFn: (variables: AdvisorImportDocumentListsVariables) =>
      fetchAdvisorImportDocumentLists({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAdvisorEventsQueryParams = {
  stream: string;
};

export type GetAdvisorEventsError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorEventsVariables = {
  queryParams: GetAdvisorEventsQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAdvisorEvents = (
  variables: GetAdvisorEventsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    GetAdvisorEventsError,
    undefined,
    {},
    GetAdvisorEventsQueryParams,
    {}
  >({ url: "/advisor/events", method: "get", ...variables, signal });

export const useGetAdvisorEvents = <TData = undefined>(
  variables: GetAdvisorEventsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetAdvisorEventsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<undefined, GetAdvisorEventsError, TData>({
    queryKey: queryKeyFn({
      path: "/advisor/events",
      operationId: "getAdvisorEvents",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorEvents({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type AdvisorAssignHubspotDealPathParams = {
  hubspotDealId: string;
};

export type AdvisorAssignHubspotDealError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorAssignHubspotDealVariables = {
  body: Schemas.HubspotDealAssignment;
  pathParams: AdvisorAssignHubspotDealPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorAssignHubspotDeal = (
  variables: AdvisorAssignHubspotDealVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorAssignHubspotDealError,
    Schemas.HubspotDealAssignment,
    {},
    {},
    AdvisorAssignHubspotDealPathParams
  >({
    url: "/advisor/hubspot/{hubspotDealId}/assign",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorAssignHubspotDeal = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorAssignHubspotDealError,
      AdvisorAssignHubspotDealVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorAssignHubspotDealError,
    AdvisorAssignHubspotDealVariables
  >({
    mutationFn: (variables: AdvisorAssignHubspotDealVariables) =>
      fetchAdvisorAssignHubspotDeal({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorGetImageQueryParams = {
  fileName: string;
};

export type AdvisorGetImageError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorGetImageVariables = {
  queryParams: AdvisorGetImageQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorGetImage = (
  variables: AdvisorGetImageVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorGetImageError,
    undefined,
    {},
    AdvisorGetImageQueryParams,
    {}
  >({ url: "/advisor/images", method: "get", ...variables, signal });

export const useAdvisorGetImage = <TData = undefined>(
  variables: AdvisorGetImageVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, AdvisorGetImageError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<undefined, AdvisorGetImageError, TData>({
    queryKey: queryKeyFn({
      path: "/advisor/images",
      operationId: "advisorGetImage",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchAdvisorGetImage({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetAdvisorLeadPathParams = {
  leadId: string;
};

export type GetAdvisorLeadError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorLeadVariables = {
  pathParams: GetAdvisorLeadPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAdvisorLead = (
  variables: GetAdvisorLeadVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Lead,
    GetAdvisorLeadError,
    undefined,
    {},
    {},
    GetAdvisorLeadPathParams
  >({ url: "/advisor/leads/{leadId}", method: "get", ...variables, signal });

export const useGetAdvisorLead = <TData = Schemas.Lead>(
  variables: GetAdvisorLeadVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Lead, GetAdvisorLeadError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<Schemas.Lead, GetAdvisorLeadError, TData>({
    queryKey: queryKeyFn({
      path: "/advisor/leads/{leadId}",
      operationId: "getAdvisorLead",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorLead({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PatchAdvisorLeadPathParams = {
  leadId: string;
};

export type PatchAdvisorLeadError = Fetcher.ErrorWrapper<undefined>;

export type PatchAdvisorLeadVariables = {
  body?: Schemas.LeadPatch;
  pathParams: PatchAdvisorLeadPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPatchAdvisorLead = (
  variables: PatchAdvisorLeadVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Lead,
    PatchAdvisorLeadError,
    Schemas.LeadPatch,
    {},
    {},
    PatchAdvisorLeadPathParams
  >({ url: "/advisor/leads/{leadId}", method: "patch", ...variables, signal });

export const usePatchAdvisorLead = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Lead,
      PatchAdvisorLeadError,
      PatchAdvisorLeadVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.Lead,
    PatchAdvisorLeadError,
    PatchAdvisorLeadVariables
  >({
    mutationFn: (variables: PatchAdvisorLeadVariables) =>
      fetchPatchAdvisorLead({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteAdvisorLeadPathParams = {
  leadId: string;
};

export type DeleteAdvisorLeadError = Fetcher.ErrorWrapper<undefined>;

export type DeleteAdvisorLeadVariables = {
  body?: Schemas.DeleteLeadBody;
  pathParams: DeleteAdvisorLeadPathParams;
} & CoreContext["fetcherOptions"];

export const fetchDeleteAdvisorLead = (
  variables: DeleteAdvisorLeadVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    DeleteAdvisorLeadError,
    Schemas.DeleteLeadBody,
    {},
    {},
    DeleteAdvisorLeadPathParams
  >({ url: "/advisor/leads/{leadId}", method: "delete", ...variables, signal });

export const useDeleteAdvisorLead = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteAdvisorLeadError,
      DeleteAdvisorLeadVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    DeleteAdvisorLeadError,
    DeleteAdvisorLeadVariables
  >({
    mutationFn: (variables: DeleteAdvisorLeadVariables) =>
      fetchDeleteAdvisorLead({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAdvisorProjectPathParams = {
  leadId: string;
  projectId: string;
};

export type GetAdvisorProjectError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorProjectVariables = {
  pathParams: GetAdvisorProjectPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAdvisorProject = (
  variables: GetAdvisorProjectVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Project,
    GetAdvisorProjectError,
    undefined,
    {},
    {},
    GetAdvisorProjectPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAdvisorProject = <TData = Schemas.Project>(
  variables: GetAdvisorProjectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Project, GetAdvisorProjectError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<Schemas.Project, GetAdvisorProjectError, TData>({
    queryKey: queryKeyFn({
      path: "/advisor/leads/{leadId}/projects/{projectId}",
      operationId: "getAdvisorProject",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorProject({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PatchAdvisorProjectPathParams = {
  leadId: string;
  projectId: string;
};

export type PatchAdvisorProjectError = Fetcher.ErrorWrapper<undefined>;

export type PatchAdvisorProjectVariables = {
  body?: Schemas.ProjectPatch;
  pathParams: PatchAdvisorProjectPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPatchAdvisorProject = (
  variables: PatchAdvisorProjectVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PatchAdvisorProjectError,
    Schemas.ProjectPatch,
    {},
    {},
    PatchAdvisorProjectPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}",
    method: "patch",
    ...variables,
    signal,
  });

export const usePatchAdvisorProject = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PatchAdvisorProjectError,
      PatchAdvisorProjectVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PatchAdvisorProjectError,
    PatchAdvisorProjectVariables
  >({
    mutationFn: (variables: PatchAdvisorProjectVariables) =>
      fetchPatchAdvisorProject({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorCloneProjectPathParams = {
  leadId: string;
  projectId: string;
};

export type AdvisorCloneProjectError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorCloneProjectVariables = {
  pathParams: AdvisorCloneProjectPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorCloneProject = (
  variables: AdvisorCloneProjectVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Project,
    AdvisorCloneProjectError,
    undefined,
    {},
    {},
    AdvisorCloneProjectPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/clone",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorCloneProject = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Project,
      AdvisorCloneProjectError,
      AdvisorCloneProjectVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.Project,
    AdvisorCloneProjectError,
    AdvisorCloneProjectVariables
  >({
    mutationFn: (variables: AdvisorCloneProjectVariables) =>
      fetchAdvisorCloneProject({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateAdvisorProjectCostsPathParams = {
  leadId: string;
  projectId: string;
};

export type UpdateAdvisorProjectCostsError = Fetcher.ErrorWrapper<undefined>;

export type UpdateAdvisorProjectCostsVariables = {
  body: Schemas.ProjectCostsPatch;
  pathParams: UpdateAdvisorProjectCostsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchUpdateAdvisorProjectCosts = (
  variables: UpdateAdvisorProjectCostsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Project,
    UpdateAdvisorProjectCostsError,
    Schemas.ProjectCostsPatch,
    {},
    {},
    UpdateAdvisorProjectCostsPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/costs",
    method: "put",
    ...variables,
    signal,
  });

export const useUpdateAdvisorProjectCosts = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Project,
      UpdateAdvisorProjectCostsError,
      UpdateAdvisorProjectCostsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.Project,
    UpdateAdvisorProjectCostsError,
    UpdateAdvisorProjectCostsVariables
  >({
    mutationFn: (variables: UpdateAdvisorProjectCostsVariables) =>
      fetchUpdateAdvisorProjectCosts({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAdvisorCrmPropertyPathParams = {
  leadId: string;
  projectId: string;
};

export type GetAdvisorCrmPropertyError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorCrmPropertyVariables = {
  pathParams: GetAdvisorCrmPropertyPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAdvisorCrmProperty = (
  variables: GetAdvisorCrmPropertyVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.PartnerCRMProperty,
    GetAdvisorCrmPropertyError,
    undefined,
    {},
    {},
    GetAdvisorCrmPropertyPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/crm-property",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAdvisorCrmProperty = <TData = Schemas.PartnerCRMProperty>(
  variables: GetAdvisorCrmPropertyVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PartnerCRMProperty,
      GetAdvisorCrmPropertyError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.PartnerCRMProperty,
    GetAdvisorCrmPropertyError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisor/leads/{leadId}/projects/{projectId}/crm-property",
      operationId: "getAdvisorCrmProperty",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorCrmProperty({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetAdvisorDocumentGroupsPathParams = {
  leadId: string;
  projectId: string;
};

export type GetAdvisorDocumentGroupsError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorDocumentGroupsResponse = Schemas.DocumentGroup[];

export type GetAdvisorDocumentGroupsVariables = {
  pathParams: GetAdvisorDocumentGroupsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAdvisorDocumentGroups = (
  variables: GetAdvisorDocumentGroupsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetAdvisorDocumentGroupsResponse,
    GetAdvisorDocumentGroupsError,
    undefined,
    {},
    {},
    GetAdvisorDocumentGroupsPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/document-groups",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAdvisorDocumentGroups = <
  TData = GetAdvisorDocumentGroupsResponse,
>(
  variables: GetAdvisorDocumentGroupsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetAdvisorDocumentGroupsResponse,
      GetAdvisorDocumentGroupsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    GetAdvisorDocumentGroupsResponse,
    GetAdvisorDocumentGroupsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisor/leads/{leadId}/projects/{projectId}/document-groups",
      operationId: "getAdvisorDocumentGroups",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorDocumentGroups(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type UpdateAdvisorDocumentListPresetPathParams = {
  leadId: string;
  projectId: string;
};

export type UpdateAdvisorDocumentListPresetQueryParams = {
  documentListId: string;
};

export type UpdateAdvisorDocumentListPresetError =
  Fetcher.ErrorWrapper<undefined>;

export type UpdateAdvisorDocumentListPresetVariables = {
  pathParams: UpdateAdvisorDocumentListPresetPathParams;
  queryParams: UpdateAdvisorDocumentListPresetQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchUpdateAdvisorDocumentListPreset = (
  variables: UpdateAdvisorDocumentListPresetVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    UpdateAdvisorDocumentListPresetError,
    undefined,
    {},
    UpdateAdvisorDocumentListPresetQueryParams,
    UpdateAdvisorDocumentListPresetPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/document-list-preset",
    method: "put",
    ...variables,
    signal,
  });

export const useUpdateAdvisorDocumentListPreset = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateAdvisorDocumentListPresetError,
      UpdateAdvisorDocumentListPresetVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    UpdateAdvisorDocumentListPresetError,
    UpdateAdvisorDocumentListPresetVariables
  >({
    mutationFn: (variables: UpdateAdvisorDocumentListPresetVariables) =>
      fetchUpdateAdvisorDocumentListPreset({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAdvisorDocumentListsPathParams = {
  leadId: string;
  projectId: string;
};

export type GetAdvisorDocumentListsError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorDocumentListsResponse = Schemas.DocumentList[];

export type GetAdvisorDocumentListsVariables = {
  pathParams: GetAdvisorDocumentListsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAdvisorDocumentLists = (
  variables: GetAdvisorDocumentListsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetAdvisorDocumentListsResponse,
    GetAdvisorDocumentListsError,
    undefined,
    {},
    {},
    GetAdvisorDocumentListsPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/document-lists",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAdvisorDocumentLists = <
  TData = GetAdvisorDocumentListsResponse,
>(
  variables: GetAdvisorDocumentListsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetAdvisorDocumentListsResponse,
      GetAdvisorDocumentListsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    GetAdvisorDocumentListsResponse,
    GetAdvisorDocumentListsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisor/leads/{leadId}/projects/{projectId}/document-lists",
      operationId: "getAdvisorDocumentLists",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorDocumentLists({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PostAdvisorDocumentFilePathParams = {
  leadId: string;
  documentId: string;
  projectId: string;
};

export type PostAdvisorDocumentFileError = Fetcher.ErrorWrapper<undefined>;

export type PostAdvisorDocumentFileVariables = {
  pathParams: PostAdvisorDocumentFilePathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostAdvisorDocumentFile = (
  variables: PostAdvisorDocumentFileVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostAdvisorDocumentFileError,
    undefined,
    {},
    {},
    PostAdvisorDocumentFilePathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/documents/{documentId}/files",
    method: "post",
    ...variables,
    signal,
  });

export const usePostAdvisorDocumentFile = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostAdvisorDocumentFileError,
      PostAdvisorDocumentFileVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostAdvisorDocumentFileError,
    PostAdvisorDocumentFileVariables
  >({
    mutationFn: (variables: PostAdvisorDocumentFileVariables) =>
      fetchPostAdvisorDocumentFile({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorDownloadFilesPathParams = {
  leadId: string;
  projectId: string;
};

export type AdvisorDownloadFilesError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorDownloadFilesVariables = {
  pathParams: AdvisorDownloadFilesPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorDownloadFiles = (
  variables: AdvisorDownloadFilesVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorDownloadFilesError,
    undefined,
    {},
    {},
    AdvisorDownloadFilesPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/download-files",
    method: "get",
    ...variables,
    signal,
  });

export const useAdvisorDownloadFiles = <TData = undefined>(
  variables: AdvisorDownloadFilesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, AdvisorDownloadFilesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<undefined, AdvisorDownloadFilesError, TData>({
    queryKey: queryKeyFn({
      path: "/advisor/leads/{leadId}/projects/{projectId}/download-files",
      operationId: "advisorDownloadFiles",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchAdvisorDownloadFiles({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type AdvisorSyncProjectFromEuropacePathParams = {
  leadId: string;
  projectId: string;
};

export type AdvisorSyncProjectFromEuropaceError =
  Fetcher.ErrorWrapper<undefined>;

export type AdvisorSyncProjectFromEuropaceVariables = {
  pathParams: AdvisorSyncProjectFromEuropacePathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorSyncProjectFromEuropace = (
  variables: AdvisorSyncProjectFromEuropaceVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Project,
    AdvisorSyncProjectFromEuropaceError,
    undefined,
    {},
    {},
    AdvisorSyncProjectFromEuropacePathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/europace-sync",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorSyncProjectFromEuropace = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Project,
      AdvisorSyncProjectFromEuropaceError,
      AdvisorSyncProjectFromEuropaceVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.Project,
    AdvisorSyncProjectFromEuropaceError,
    AdvisorSyncProjectFromEuropaceVariables
  >({
    mutationFn: (variables: AdvisorSyncProjectFromEuropaceVariables) =>
      fetchAdvisorSyncProjectFromEuropace({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ExportAdvisorDocumentsPathParams = {
  leadId: string;
  projectId: string;
};

export type ExportAdvisorDocumentsError = Fetcher.ErrorWrapper<undefined>;

export type ExportAdvisorDocumentsVariables = {
  body: Schemas.ExportDocumentsRequest;
  pathParams: ExportAdvisorDocumentsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchExportAdvisorDocuments = (
  variables: ExportAdvisorDocumentsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Task,
    ExportAdvisorDocumentsError,
    Schemas.ExportDocumentsRequest,
    {},
    {},
    ExportAdvisorDocumentsPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/export",
    method: "post",
    ...variables,
    signal,
  });

export const useExportAdvisorDocuments = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Task,
      ExportAdvisorDocumentsError,
      ExportAdvisorDocumentsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.Task,
    ExportAdvisorDocumentsError,
    ExportAdvisorDocumentsVariables
  >({
    mutationFn: (variables: ExportAdvisorDocumentsVariables) =>
      fetchExportAdvisorDocuments({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostAdvisorFilePathParams = {
  leadId: string;
  projectId: string;
};

export type PostAdvisorFileError = Fetcher.ErrorWrapper<undefined>;

export type PostAdvisorFileVariables = {
  pathParams: PostAdvisorFilePathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostAdvisorFile = (
  variables: PostAdvisorFileVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Task,
    PostAdvisorFileError,
    undefined,
    {},
    {},
    PostAdvisorFilePathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/files",
    method: "post",
    ...variables,
    signal,
  });

export const usePostAdvisorFile = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Task,
      PostAdvisorFileError,
      PostAdvisorFileVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.Task,
    PostAdvisorFileError,
    PostAdvisorFileVariables
  >({
    mutationFn: (variables: PostAdvisorFileVariables) =>
      fetchPostAdvisorFile({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorGenerateCertificatePathParams = {
  leadId: string;
  projectId: string;
};

export type AdvisorGenerateCertificateError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorGenerateCertificateResponse = Schemas.OfferPreview[];

export type AdvisorGenerateCertificateVariables = {
  pathParams: AdvisorGenerateCertificatePathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorGenerateCertificate = (
  variables: AdvisorGenerateCertificateVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    AdvisorGenerateCertificateResponse,
    AdvisorGenerateCertificateError,
    undefined,
    {},
    {},
    AdvisorGenerateCertificatePathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/generate-certificate",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorGenerateCertificate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      AdvisorGenerateCertificateResponse,
      AdvisorGenerateCertificateError,
      AdvisorGenerateCertificateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    AdvisorGenerateCertificateResponse,
    AdvisorGenerateCertificateError,
    AdvisorGenerateCertificateVariables
  >({
    mutationFn: (variables: AdvisorGenerateCertificateVariables) =>
      fetchAdvisorGenerateCertificate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorGenerateOffersPathParams = {
  leadId: string;
  projectId: string;
};

export type AdvisorGenerateOffersError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorGenerateOffersResponse = Schemas.OfferPreview[];

export type AdvisorGenerateOffersVariables = {
  pathParams: AdvisorGenerateOffersPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorGenerateOffers = (
  variables: AdvisorGenerateOffersVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    AdvisorGenerateOffersResponse,
    AdvisorGenerateOffersError,
    undefined,
    {},
    {},
    AdvisorGenerateOffersPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/generate-offers",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorGenerateOffers = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      AdvisorGenerateOffersResponse,
      AdvisorGenerateOffersError,
      AdvisorGenerateOffersVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    AdvisorGenerateOffersResponse,
    AdvisorGenerateOffersError,
    AdvisorGenerateOffersVariables
  >({
    mutationFn: (variables: AdvisorGenerateOffersVariables) =>
      fetchAdvisorGenerateOffers({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetUnimportedAdvisorDocumentsPathParams = {
  leadId: string;
  projectId: string;
};

export type GetUnimportedAdvisorDocumentsError =
  Fetcher.ErrorWrapper<undefined>;

export type GetUnimportedAdvisorDocumentsVariables = {
  pathParams: GetUnimportedAdvisorDocumentsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetUnimportedAdvisorDocuments = (
  variables: GetUnimportedAdvisorDocumentsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.DocumentImportCount,
    GetUnimportedAdvisorDocumentsError,
    undefined,
    {},
    {},
    GetUnimportedAdvisorDocumentsPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/import",
    method: "get",
    ...variables,
    signal,
  });

export const useGetUnimportedAdvisorDocuments = <
  TData = Schemas.DocumentImportCount,
>(
  variables: GetUnimportedAdvisorDocumentsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DocumentImportCount,
      GetUnimportedAdvisorDocumentsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.DocumentImportCount,
    GetUnimportedAdvisorDocumentsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisor/leads/{leadId}/projects/{projectId}/import",
      operationId: "getUnimportedAdvisorDocuments",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetUnimportedAdvisorDocuments(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ImportAdvisorDocumentsPathParams = {
  leadId: string;
  projectId: string;
};

export type ImportAdvisorDocumentsError = Fetcher.ErrorWrapper<undefined>;

export type ImportAdvisorDocumentsResponse = Schemas.Task[];

export type ImportAdvisorDocumentsVariables = {
  pathParams: ImportAdvisorDocumentsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchImportAdvisorDocuments = (
  variables: ImportAdvisorDocumentsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    ImportAdvisorDocumentsResponse,
    ImportAdvisorDocumentsError,
    undefined,
    {},
    {},
    ImportAdvisorDocumentsPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/import",
    method: "post",
    ...variables,
    signal,
  });

export const useImportAdvisorDocuments = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ImportAdvisorDocumentsResponse,
      ImportAdvisorDocumentsError,
      ImportAdvisorDocumentsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    ImportAdvisorDocumentsResponse,
    ImportAdvisorDocumentsError,
    ImportAdvisorDocumentsVariables
  >({
    mutationFn: (variables: ImportAdvisorDocumentsVariables) =>
      fetchImportAdvisorDocuments({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorPostPropertyValuationPathParams = {
  leadId: string;
  projectId: string;
};

export type AdvisorPostPropertyValuationError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorPostPropertyValuationVariables = {
  body: Schemas.PropertyValuation;
  pathParams: AdvisorPostPropertyValuationPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorPostPropertyValuation = (
  variables: AdvisorPostPropertyValuationVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.PropertyValuation,
    AdvisorPostPropertyValuationError,
    Schemas.PropertyValuation,
    {},
    {},
    AdvisorPostPropertyValuationPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/property-valuations",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorPostPropertyValuation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PropertyValuation,
      AdvisorPostPropertyValuationError,
      AdvisorPostPropertyValuationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.PropertyValuation,
    AdvisorPostPropertyValuationError,
    AdvisorPostPropertyValuationVariables
  >({
    mutationFn: (variables: AdvisorPostPropertyValuationVariables) =>
      fetchAdvisorPostPropertyValuation({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAdvisorProjectRelatedProjectsPathParams = {
  leadId: string;
  projectId: string;
};

export type GetAdvisorProjectRelatedProjectsError =
  Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorProjectRelatedProjectsVariables = {
  pathParams: GetAdvisorProjectRelatedProjectsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAdvisorProjectRelatedProjects = (
  variables: GetAdvisorProjectRelatedProjectsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.PartnerProperty,
    GetAdvisorProjectRelatedProjectsError,
    undefined,
    {},
    {},
    GetAdvisorProjectRelatedProjectsPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/related-projects",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAdvisorProjectRelatedProjects = <
  TData = Schemas.PartnerProperty,
>(
  variables: GetAdvisorProjectRelatedProjectsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PartnerProperty,
      GetAdvisorProjectRelatedProjectsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.PartnerProperty,
    GetAdvisorProjectRelatedProjectsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisor/leads/{leadId}/projects/{projectId}/related-projects",
      operationId: "getAdvisorProjectRelatedProjects",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorProjectRelatedProjects(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type AdvisorSendSavedOffersPathParams = {
  leadId: string;
  projectId: string;
};

export type AdvisorSendSavedOffersError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorSendSavedOffersVariables = {
  body: Schemas.SavedOffersEmail;
  pathParams: AdvisorSendSavedOffersPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorSendSavedOffers = (
  variables: AdvisorSendSavedOffersVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorSendSavedOffersError,
    Schemas.SavedOffersEmail,
    {},
    {},
    AdvisorSendSavedOffersPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/saved-offers/send",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorSendSavedOffers = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorSendSavedOffersError,
      AdvisorSendSavedOffersVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorSendSavedOffersError,
    AdvisorSendSavedOffersVariables
  >({
    mutationFn: (variables: AdvisorSendSavedOffersVariables) =>
      fetchAdvisorSendSavedOffers({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorDownloadSavedOffersPdfPathParams = {
  leadId: string;
  projectId: string;
};

export type AdvisorDownloadSavedOffersPdfError =
  Fetcher.ErrorWrapper<undefined>;

export type AdvisorDownloadSavedOffersPdfVariables = {
  pathParams: AdvisorDownloadSavedOffersPdfPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorDownloadSavedOffersPdf = (
  variables: AdvisorDownloadSavedOffersPdfVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorDownloadSavedOffersPdfError,
    undefined,
    {},
    {},
    AdvisorDownloadSavedOffersPdfPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/saved-offers/download-pdf",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorDownloadSavedOffersPdf = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorDownloadSavedOffersPdfError,
      AdvisorDownloadSavedOffersPdfVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorDownloadSavedOffersPdfError,
    AdvisorDownloadSavedOffersPdfVariables
  >({
    mutationFn: (variables: AdvisorDownloadSavedOffersPdfVariables) =>
      fetchAdvisorDownloadSavedOffersPdf({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAdvisorPartnerPathParams = {
  partnerId: string;
};

export type GetAdvisorPartnerError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorPartnerVariables = {
  pathParams: GetAdvisorPartnerPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAdvisorPartner = (
  variables: GetAdvisorPartnerVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.Partner,
    GetAdvisorPartnerError,
    undefined,
    {},
    {},
    GetAdvisorPartnerPathParams
  >({
    url: "/advisor/partners/{partnerId}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAdvisorPartner = <TData = Schemas.Partner>(
  variables: GetAdvisorPartnerVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Partner, GetAdvisorPartnerError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<Schemas.Partner, GetAdvisorPartnerError, TData>({
    queryKey: queryKeyFn({
      path: "/advisor/partners/{partnerId}",
      operationId: "getAdvisorPartner",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorPartner({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type AdvisorGetPartnerDocumentSettingsPathParams = {
  partnerId: string;
};

export type AdvisorGetPartnerDocumentSettingsError =
  Fetcher.ErrorWrapper<undefined>;

export type AdvisorGetPartnerDocumentSettingsVariables = {
  pathParams: AdvisorGetPartnerDocumentSettingsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorGetPartnerDocumentSettings = (
  variables: AdvisorGetPartnerDocumentSettingsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.DocumentSettings,
    AdvisorGetPartnerDocumentSettingsError,
    undefined,
    {},
    {},
    AdvisorGetPartnerDocumentSettingsPathParams
  >({
    url: "/advisor/partners/{partnerId}/document-settings",
    method: "get",
    ...variables,
    signal,
  });

export const useAdvisorGetPartnerDocumentSettings = <
  TData = Schemas.DocumentSettings,
>(
  variables: AdvisorGetPartnerDocumentSettingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DocumentSettings,
      AdvisorGetPartnerDocumentSettingsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.DocumentSettings,
    AdvisorGetPartnerDocumentSettingsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisor/partners/{partnerId}/document-settings",
      operationId: "advisorGetPartnerDocumentSettings",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchAdvisorGetPartnerDocumentSettings(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type GetAdvisorSearchProjectsQueryParams = {
  query: string;
  page?: number;
  limit?: number;
};

export type GetAdvisorSearchProjectsError = Fetcher.ErrorWrapper<undefined>;

export type GetAdvisorSearchProjectsResponse = Schemas.ProjectSearch[];

export type GetAdvisorSearchProjectsVariables = {
  queryParams: GetAdvisorSearchProjectsQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAdvisorSearchProjects = (
  variables: GetAdvisorSearchProjectsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetAdvisorSearchProjectsResponse,
    GetAdvisorSearchProjectsError,
    undefined,
    {},
    GetAdvisorSearchProjectsQueryParams,
    {}
  >({ url: "/advisor/projects/search", method: "get", ...variables, signal });

export const useGetAdvisorSearchProjects = <
  TData = GetAdvisorSearchProjectsResponse,
>(
  variables: GetAdvisorSearchProjectsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetAdvisorSearchProjectsResponse,
      GetAdvisorSearchProjectsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    GetAdvisorSearchProjectsResponse,
    GetAdvisorSearchProjectsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisor/projects/search",
      operationId: "getAdvisorSearchProjects",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAdvisorSearchProjects(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type AdvisorGetCommentsByProjectIdPathParams = {
  projectId: string;
};

export type AdvisorGetCommentsByProjectIdError =
  Fetcher.ErrorWrapper<undefined>;

export type AdvisorGetCommentsByProjectIdResponse =
  Schemas.DocumentPageComment[];

export type AdvisorGetCommentsByProjectIdVariables = {
  pathParams: AdvisorGetCommentsByProjectIdPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorGetCommentsByProjectId = (
  variables: AdvisorGetCommentsByProjectIdVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    AdvisorGetCommentsByProjectIdResponse,
    AdvisorGetCommentsByProjectIdError,
    undefined,
    {},
    {},
    AdvisorGetCommentsByProjectIdPathParams
  >({
    url: "/advisor/projects/{projectId}/comments",
    method: "get",
    ...variables,
    signal,
  });

export const useAdvisorGetCommentsByProjectId = <
  TData = AdvisorGetCommentsByProjectIdResponse,
>(
  variables: AdvisorGetCommentsByProjectIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      AdvisorGetCommentsByProjectIdResponse,
      AdvisorGetCommentsByProjectIdError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    AdvisorGetCommentsByProjectIdResponse,
    AdvisorGetCommentsByProjectIdError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisor/projects/{projectId}/comments",
      operationId: "advisorGetCommentsByProjectId",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchAdvisorGetCommentsByProjectId(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type AdvisorCreateCommentPathParams = {
  projectId: string;
};

export type AdvisorCreateCommentError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorCreateCommentVariables = {
  body: Schemas.PostDocumentPageComment;
  pathParams: AdvisorCreateCommentPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorCreateComment = (
  variables: AdvisorCreateCommentVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.DocumentPageComment,
    AdvisorCreateCommentError,
    Schemas.PostDocumentPageComment,
    {},
    {},
    AdvisorCreateCommentPathParams
  >({
    url: "/advisor/projects/{projectId}/comments",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorCreateComment = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DocumentPageComment,
      AdvisorCreateCommentError,
      AdvisorCreateCommentVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.DocumentPageComment,
    AdvisorCreateCommentError,
    AdvisorCreateCommentVariables
  >({
    mutationFn: (variables: AdvisorCreateCommentVariables) =>
      fetchAdvisorCreateComment({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorPublishExternalCommentsPathParams = {
  projectId: string;
};

export type AdvisorPublishExternalCommentsError =
  Fetcher.ErrorWrapper<undefined>;

export type AdvisorPublishExternalCommentsVariables = {
  pathParams: AdvisorPublishExternalCommentsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorPublishExternalComments = (
  variables: AdvisorPublishExternalCommentsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorPublishExternalCommentsError,
    undefined,
    {},
    {},
    AdvisorPublishExternalCommentsPathParams
  >({
    url: "/advisor/projects/{projectId}/comments/publish",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorPublishExternalComments = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorPublishExternalCommentsError,
      AdvisorPublishExternalCommentsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorPublishExternalCommentsError,
    AdvisorPublishExternalCommentsVariables
  >({
    mutationFn: (variables: AdvisorPublishExternalCommentsVariables) =>
      fetchAdvisorPublishExternalComments({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorUpdateProjectPathParams = {
  projectId: string;
};

export type AdvisorUpdateProjectError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorUpdateProjectVariables = {
  body: Schemas.Project;
  pathParams: AdvisorUpdateProjectPathParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorUpdateProject = (
  variables: AdvisorUpdateProjectVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    AdvisorUpdateProjectError,
    Schemas.Project,
    {},
    {},
    AdvisorUpdateProjectPathParams
  >({
    url: "/advisor/projects/{projectId}/update-project",
    method: "post",
    ...variables,
    signal,
  });

export const useAdvisorUpdateProject = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdvisorUpdateProjectError,
      AdvisorUpdateProjectVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    AdvisorUpdateProjectError,
    AdvisorUpdateProjectVariables
  >({
    mutationFn: (variables: AdvisorUpdateProjectVariables) =>
      fetchAdvisorUpdateProject({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdvisorSearchDocumentsPathParams = {
  leadId: string;
  projectId: string;
};

export type AdvisorSearchDocumentsQueryParams = {
  /**
   * Search query term
   */
  q: string;
  /**
   * Maximum number of results to return
   *
   * @default 10
   */
  limit?: number;
};

export type AdvisorSearchDocumentsError = Fetcher.ErrorWrapper<undefined>;

export type AdvisorSearchDocumentsResponse = Schemas.SearchResult[];

export type AdvisorSearchDocumentsVariables = {
  pathParams: AdvisorSearchDocumentsPathParams;
  queryParams: AdvisorSearchDocumentsQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchAdvisorSearchDocuments = (
  variables: AdvisorSearchDocumentsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    AdvisorSearchDocumentsResponse,
    AdvisorSearchDocumentsError,
    undefined,
    {},
    AdvisorSearchDocumentsQueryParams,
    AdvisorSearchDocumentsPathParams
  >({
    url: "/advisor/leads/{leadId}/projects/{projectId}/search",
    method: "get",
    ...variables,
    signal,
  });

export const useAdvisorSearchDocuments = <
  TData = AdvisorSearchDocumentsResponse,
>(
  variables: AdvisorSearchDocumentsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      AdvisorSearchDocumentsResponse,
      AdvisorSearchDocumentsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    AdvisorSearchDocumentsResponse,
    AdvisorSearchDocumentsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/advisor/leads/{leadId}/projects/{projectId}/search",
      operationId: "advisorSearchDocuments",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchAdvisorSearchDocuments({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PostNewProjectPathParams = {
  chatId: string;
};

export type PostNewProjectError = Fetcher.ErrorWrapper<undefined>;

export type PostNewProjectVariables = {
  body?: Schemas.NewProjectRequest;
  pathParams: PostNewProjectPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostNewProject = (
  variables: PostNewProjectVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostNewProjectError,
    Schemas.NewProjectRequest,
    {},
    {},
    PostNewProjectPathParams
  >({
    url: "/app/assistant-chat/{chatId}/new-project",
    method: "post",
    ...variables,
    signal,
  });

export const usePostNewProject = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostNewProjectError,
      PostNewProjectVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostNewProjectError,
    PostNewProjectVariables
  >({
    mutationFn: (variables: PostNewProjectVariables) =>
      fetchPostNewProject({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostAssistantChatError = Fetcher.ErrorWrapper<undefined>;

export type PostAssistantChatVariables = {
  body: Schemas.NewAssistantChat;
} & CoreContext["fetcherOptions"];

export const fetchPostAssistantChat = (
  variables: PostAssistantChatVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.OnboardingAssistantChat,
    PostAssistantChatError,
    Schemas.NewAssistantChat,
    {},
    {},
    {}
  >({ url: "/app/assistant-chats", method: "post", ...variables, signal });

export const usePostAssistantChat = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.OnboardingAssistantChat,
      PostAssistantChatError,
      PostAssistantChatVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.OnboardingAssistantChat,
    PostAssistantChatError,
    PostAssistantChatVariables
  >({
    mutationFn: (variables: PostAssistantChatVariables) =>
      fetchPostAssistantChat({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAssistantChatPathParams = {
  chatId: string;
};

export type GetAssistantChatError = Fetcher.ErrorWrapper<undefined>;

export type GetAssistantChatVariables = {
  pathParams: GetAssistantChatPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAssistantChat = (
  variables: GetAssistantChatVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.OnboardingAssistantChatV2,
    GetAssistantChatError,
    undefined,
    {},
    {},
    GetAssistantChatPathParams
  >({
    url: "/app/assistant-chats/{chatId}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAssistantChat = <TData = Schemas.OnboardingAssistantChatV2>(
  variables: GetAssistantChatVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.OnboardingAssistantChatV2,
      GetAssistantChatError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.OnboardingAssistantChatV2,
    GetAssistantChatError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/app/assistant-chats/{chatId}",
      operationId: "getAssistantChat",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAssistantChat({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type UpdateAssistantChatPathParams = {
  chatId: string;
};

export type UpdateAssistantChatError = Fetcher.ErrorWrapper<undefined>;

export type UpdateAssistantChatVariables = {
  body: Schemas.OnboardingAssistantChatV2;
  pathParams: UpdateAssistantChatPathParams;
} & CoreContext["fetcherOptions"];

export const fetchUpdateAssistantChat = (
  variables: UpdateAssistantChatVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    UpdateAssistantChatError,
    Schemas.OnboardingAssistantChatV2,
    {},
    {},
    UpdateAssistantChatPathParams
  >({
    url: "/app/assistant-chats/{chatId}",
    method: "put",
    ...variables,
    signal,
  });

export const useUpdateAssistantChat = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateAssistantChatError,
      UpdateAssistantChatVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    UpdateAssistantChatError,
    UpdateAssistantChatVariables
  >({
    mutationFn: (variables: UpdateAssistantChatVariables) =>
      fetchUpdateAssistantChat({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostFinishAssistantChatPathParams = {
  chatId: string;
};

export type PostFinishAssistantChatError = Fetcher.ErrorWrapper<undefined>;

export type PostFinishAssistantChatVariables = {
  pathParams: PostFinishAssistantChatPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostFinishAssistantChat = (
  variables: PostFinishAssistantChatVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostFinishAssistantChatError,
    undefined,
    {},
    {},
    PostFinishAssistantChatPathParams
  >({
    url: "/app/assistant-chats/{chatId}/finish",
    method: "post",
    ...variables,
    signal,
  });

export const usePostFinishAssistantChat = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostFinishAssistantChatError,
      PostFinishAssistantChatVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostFinishAssistantChatError,
    PostFinishAssistantChatVariables
  >({
    mutationFn: (variables: PostFinishAssistantChatVariables) =>
      fetchPostFinishAssistantChat({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PutAssistantChatNpsPathParams = {
  chatId: string;
};

export type PutAssistantChatNpsError = Fetcher.ErrorWrapper<undefined>;

export type PutAssistantChatNpsVariables = {
  body: Schemas.PutNpsScore;
  pathParams: PutAssistantChatNpsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPutAssistantChatNps = (
  variables: PutAssistantChatNpsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PutAssistantChatNpsError,
    Schemas.PutNpsScore,
    {},
    {},
    PutAssistantChatNpsPathParams
  >({
    url: "/app/assistant-chats/{chatId}/nps",
    method: "put",
    ...variables,
    signal,
  });

export const usePutAssistantChatNps = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PutAssistantChatNpsError,
      PutAssistantChatNpsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PutAssistantChatNpsError,
    PutAssistantChatNpsVariables
  >({
    mutationFn: (variables: PutAssistantChatNpsVariables) =>
      fetchPutAssistantChatNps({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAppDocumentTypesError = Fetcher.ErrorWrapper<undefined>;

export type GetAppDocumentTypesResponse = Schemas.DocumentType[];

export type GetAppDocumentTypesVariables = CoreContext["fetcherOptions"];

export const fetchGetAppDocumentTypes = (
  variables: GetAppDocumentTypesVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetAppDocumentTypesResponse,
    GetAppDocumentTypesError,
    undefined,
    {},
    {},
    {}
  >({ url: "/app/document-types", method: "get", ...variables, signal });

export const useGetAppDocumentTypes = <TData = GetAppDocumentTypesResponse>(
  variables: GetAppDocumentTypesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetAppDocumentTypesResponse,
      GetAppDocumentTypesError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    GetAppDocumentTypesResponse,
    GetAppDocumentTypesError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/app/document-types",
      operationId: "getAppDocumentTypes",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAppDocumentTypes({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetEnhancedLeadError = Fetcher.ErrorWrapper<undefined>;

export type GetEnhancedLeadVariables = CoreContext["fetcherOptions"];

export const fetchGetEnhancedLead = (
  variables: GetEnhancedLeadVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.EnhancedLeadInfo,
    GetEnhancedLeadError,
    undefined,
    {},
    {},
    {}
  >({ url: "/app/lead", method: "get", ...variables, signal });

export const useGetEnhancedLead = <TData = Schemas.EnhancedLeadInfo>(
  variables: GetEnhancedLeadVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.EnhancedLeadInfo,
      GetEnhancedLeadError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.EnhancedLeadInfo,
    GetEnhancedLeadError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/app/lead",
      operationId: "getEnhancedLead",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetEnhancedLead({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PostAppEuropaceSyncError = Fetcher.ErrorWrapper<undefined>;

export type PostAppEuropaceSyncVariables = CoreContext["fetcherOptions"];

export const fetchPostAppEuropaceSync = (
  variables: PostAppEuropaceSyncVariables,
  signal?: AbortSignal,
) =>
  coreFetch<undefined, PostAppEuropaceSyncError, undefined, {}, {}, {}>({
    url: "/app/projects/europace-sync",
    method: "post",
    ...variables,
    signal,
  });

export const usePostAppEuropaceSync = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostAppEuropaceSyncError,
      PostAppEuropaceSyncVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostAppEuropaceSyncError,
    PostAppEuropaceSyncVariables
  >({
    mutationFn: (variables: PostAppEuropaceSyncVariables) =>
      fetchPostAppEuropaceSync({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateProjectPathParams = {
  projectId: string;
};

export type UpdateProjectError = Fetcher.ErrorWrapper<undefined>;

export type UpdateProjectVariables = {
  body: Schemas.Project;
  pathParams: UpdateProjectPathParams;
} & CoreContext["fetcherOptions"];

export const fetchUpdateProject = (
  variables: UpdateProjectVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    UpdateProjectError,
    Schemas.Project,
    {},
    {},
    UpdateProjectPathParams
  >({ url: "/app/projects/{projectId}", method: "put", ...variables, signal });

export const useUpdateProject = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateProjectError,
      UpdateProjectVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    UpdateProjectError,
    UpdateProjectVariables
  >({
    mutationFn: (variables: UpdateProjectVariables) =>
      fetchUpdateProject({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetCommentsPathParams = {
  projectId: string;
};

export type GetCommentsError = Fetcher.ErrorWrapper<undefined>;

export type GetCommentsResponse = Schemas.DocumentPageComment[];

export type GetCommentsVariables = {
  pathParams: GetCommentsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetComments = (
  variables: GetCommentsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetCommentsResponse,
    GetCommentsError,
    undefined,
    {},
    {},
    GetCommentsPathParams
  >({
    url: "/app/projects/{projectId}/comments",
    method: "get",
    ...variables,
    signal,
  });

export const useGetComments = <TData = GetCommentsResponse>(
  variables: GetCommentsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetCommentsResponse, GetCommentsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<GetCommentsResponse, GetCommentsError, TData>({
    queryKey: queryKeyFn({
      path: "/app/projects/{projectId}/comments",
      operationId: "getComments",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetComments({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetAppDocumentListsPathParams = {
  projectId: string;
};

export type GetAppDocumentListsError = Fetcher.ErrorWrapper<undefined>;

export type GetAppDocumentListsResponse = Schemas.DocumentList[];

export type GetAppDocumentListsVariables = {
  pathParams: GetAppDocumentListsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAppDocumentLists = (
  variables: GetAppDocumentListsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetAppDocumentListsResponse,
    GetAppDocumentListsError,
    undefined,
    {},
    {},
    GetAppDocumentListsPathParams
  >({
    url: "/app/projects/{projectId}/document-lists",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAppDocumentLists = <TData = GetAppDocumentListsResponse>(
  variables: GetAppDocumentListsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetAppDocumentListsResponse,
      GetAppDocumentListsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    GetAppDocumentListsResponse,
    GetAppDocumentListsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/app/projects/{projectId}/document-lists",
      operationId: "getAppDocumentLists",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAppDocumentLists({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetDocumentsPathParams = {
  projectId: string;
};

export type GetDocumentsError = Fetcher.ErrorWrapper<undefined>;

export type GetDocumentsResponse = Schemas.DocumentGroup[];

export type GetDocumentsVariables = {
  pathParams: GetDocumentsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetDocuments = (
  variables: GetDocumentsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetDocumentsResponse,
    GetDocumentsError,
    undefined,
    {},
    {},
    GetDocumentsPathParams
  >({
    url: "/app/projects/{projectId}/documents",
    method: "get",
    ...variables,
    signal,
  });

export const useGetDocuments = <TData = GetDocumentsResponse>(
  variables: GetDocumentsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetDocumentsResponse, GetDocumentsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<GetDocumentsResponse, GetDocumentsError, TData>({
    queryKey: queryKeyFn({
      path: "/app/projects/{projectId}/documents",
      operationId: "getDocuments",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetDocuments({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PostFilePathParams = {
  projectId: string;
  documentId: string;
};

export type PostFileError = Fetcher.ErrorWrapper<undefined>;

export type PostFileVariables = {
  pathParams: PostFilePathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostFile = (
  variables: PostFileVariables,
  signal?: AbortSignal,
) =>
  coreFetch<undefined, PostFileError, undefined, {}, {}, PostFilePathParams>({
    url: "/app/projects/{projectId}/documents/{documentId}/files",
    method: "post",
    ...variables,
    signal,
  });

export const usePostFile = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, PostFileError, PostFileVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<undefined, PostFileError, PostFileVariables>({
    mutationFn: (variables: PostFileVariables) =>
      fetchPostFile({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ArchiveFilePathParams = {
  documentId: string;
  projectId: string;
  fileId: string;
};

export type ArchiveFileError = Fetcher.ErrorWrapper<undefined>;

export type ArchiveFileVariables = {
  pathParams: ArchiveFilePathParams;
} & CoreContext["fetcherOptions"];

export const fetchArchiveFile = (
  variables: ArchiveFileVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    ArchiveFileError,
    undefined,
    {},
    {},
    ArchiveFilePathParams
  >({
    url: "/app/projects/{projectId}/documents/{documentId}/files/{fileId}/archive",
    method: "post",
    ...variables,
    signal,
  });

export const useArchiveFile = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ArchiveFileError,
      ArchiveFileVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    ArchiveFileError,
    ArchiveFileVariables
  >({
    mutationFn: (variables: ArchiveFileVariables) =>
      fetchArchiveFile({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAppFinancingCertificatePathParams = {
  projectId: string;
};

export type GetAppFinancingCertificateError = Fetcher.ErrorWrapper<undefined>;

export type GetAppFinancingCertificateVariables = {
  pathParams: GetAppFinancingCertificatePathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAppFinancingCertificate = (
  variables: GetAppFinancingCertificateVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    string,
    GetAppFinancingCertificateError,
    undefined,
    {},
    {},
    GetAppFinancingCertificatePathParams
  >({
    url: "/app/projects/{projectId}/financing-certificate",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAppFinancingCertificate = <TData = string>(
  variables: GetAppFinancingCertificateVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<string, GetAppFinancingCertificateError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<string, GetAppFinancingCertificateError, TData>({
    queryKey: queryKeyFn({
      path: "/app/projects/{projectId}/financing-certificate",
      operationId: "getAppFinancingCertificate",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAppFinancingCertificate(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type GetAppOfferDocumentsPathParams = {
  projectId: string;
};

export type GetAppOfferDocumentsError = Fetcher.ErrorWrapper<undefined>;

export type GetAppOfferDocumentsResponse = Schemas.OfferDocument[];

export type GetAppOfferDocumentsVariables = {
  pathParams: GetAppOfferDocumentsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAppOfferDocuments = (
  variables: GetAppOfferDocumentsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetAppOfferDocumentsResponse,
    GetAppOfferDocumentsError,
    undefined,
    {},
    {},
    GetAppOfferDocumentsPathParams
  >({
    url: "/app/projects/{projectId}/offer-documents",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAppOfferDocuments = <TData = GetAppOfferDocumentsResponse>(
  variables: GetAppOfferDocumentsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetAppOfferDocumentsResponse,
      GetAppOfferDocumentsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    GetAppOfferDocumentsResponse,
    GetAppOfferDocumentsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/app/projects/{projectId}/offer-documents",
      operationId: "getAppOfferDocuments",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAppOfferDocuments({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetAppSavedOffersPathParams = {
  projectId: string;
};

export type GetAppSavedOffersError = Fetcher.ErrorWrapper<undefined>;

export type GetAppSavedOffersResponse = Schemas.OfferPreview[];

export type GetAppSavedOffersVariables = {
  pathParams: GetAppSavedOffersPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetAppSavedOffers = (
  variables: GetAppSavedOffersVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetAppSavedOffersResponse,
    GetAppSavedOffersError,
    undefined,
    {},
    {},
    GetAppSavedOffersPathParams
  >({
    url: "/app/projects/{projectId}/saved-offers",
    method: "get",
    ...variables,
    signal,
  });

export const useGetAppSavedOffers = <TData = GetAppSavedOffersResponse>(
  variables: GetAppSavedOffersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetAppSavedOffersResponse,
      GetAppSavedOffersError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    GetAppSavedOffersResponse,
    GetAppSavedOffersError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/app/projects/{projectId}/saved-offers",
      operationId: "getAppSavedOffers",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetAppSavedOffers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetDocumentsCrmCardQueryParams = {
  associatedObjectId: string;
};

export type GetDocumentsCrmCardError = Fetcher.ErrorWrapper<undefined>;

export type GetDocumentsCrmCardVariables = {
  queryParams: GetDocumentsCrmCardQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchGetDocumentsCrmCard = (
  variables: GetDocumentsCrmCardVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    GetDocumentsCrmCardError,
    undefined,
    {},
    GetDocumentsCrmCardQueryParams,
    {}
  >({
    url: "/hubspot/v1/crm-card/documents",
    method: "get",
    ...variables,
    signal,
  });

export const useGetDocumentsCrmCard = <
  TData = Schemas.HubspotCardActionResponse,
>(
  variables: GetDocumentsCrmCardVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.HubspotCardActionResponse,
      GetDocumentsCrmCardError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.HubspotCardActionResponse,
    GetDocumentsCrmCardError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/hubspot/v1/crm-card/documents",
      operationId: "getDocumentsCrmCard",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetDocumentsCrmCard({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type SendDocumentsLinkQueryParams = {
  leadId: string;
  projectId: string;
};

export type SendDocumentsLinkError = Fetcher.ErrorWrapper<undefined>;

export type SendDocumentsLinkVariables = {
  queryParams: SendDocumentsLinkQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchSendDocumentsLink = (
  variables: SendDocumentsLinkVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    SendDocumentsLinkError,
    undefined,
    {},
    SendDocumentsLinkQueryParams,
    {}
  >({
    url: "/hubspot/v1/crm-card/documents",
    method: "post",
    ...variables,
    signal,
  });

export const useSendDocumentsLink = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SendDocumentsLinkError,
      SendDocumentsLinkVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    SendDocumentsLinkError,
    SendDocumentsLinkVariables
  >({
    mutationFn: (variables: SendDocumentsLinkVariables) =>
      fetchSendDocumentsLink({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PushProjectToEuropaceQueryParams = {
  projectId: string;
  /**
   */
  leadId: string;
};

export type PushProjectToEuropaceError = Fetcher.ErrorWrapper<undefined>;

export type PushProjectToEuropaceVariables = {
  queryParams: PushProjectToEuropaceQueryParams;
} & CoreContext["fetcherOptions"];

/**
 * The endpoint used for exporting to other external systems (Europace)
 */
export const fetchPushProjectToEuropace = (
  variables: PushProjectToEuropaceVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    PushProjectToEuropaceError,
    undefined,
    {},
    PushProjectToEuropaceQueryParams,
    {}
  >({
    url: "/hubspot/v1/crm-card/europace/push",
    method: "post",
    ...variables,
    signal,
  });

/**
 * The endpoint used for exporting to other external systems (Europace)
 */
export const usePushProjectToEuropace = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.HubspotCardActionResponse,
      PushProjectToEuropaceError,
      PushProjectToEuropaceVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.HubspotCardActionResponse,
    PushProjectToEuropaceError,
    PushProjectToEuropaceVariables
  >({
    mutationFn: (variables: PushProjectToEuropaceVariables) =>
      fetchPushProjectToEuropace({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CloneEuropaceCasePathParams = {
  europaceCaseId: string;
};

export type CloneEuropaceCaseQueryParams = {
  hubspotDealId: string;
};

export type CloneEuropaceCaseError = Fetcher.ErrorWrapper<undefined>;

export type CloneEuropaceCaseVariables = {
  pathParams: CloneEuropaceCasePathParams;
  queryParams: CloneEuropaceCaseQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchCloneEuropaceCase = (
  variables: CloneEuropaceCaseVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    CloneEuropaceCaseError,
    undefined,
    {},
    CloneEuropaceCaseQueryParams,
    CloneEuropaceCasePathParams
  >({
    url: "/hubspot/v1/crm-card/europace/{europaceCaseId}/clone",
    method: "post",
    ...variables,
    signal,
  });

export const useCloneEuropaceCase = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.HubspotCardActionResponse,
      CloneEuropaceCaseError,
      CloneEuropaceCaseVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.HubspotCardActionResponse,
    CloneEuropaceCaseError,
    CloneEuropaceCaseVariables
  >({
    mutationFn: (variables: CloneEuropaceCaseVariables) =>
      fetchCloneEuropaceCase({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PullEuropaceCasePathParams = {
  europaceCaseId: string;
};

export type PullEuropaceCaseError = Fetcher.ErrorWrapper<undefined>;

export type PullEuropaceCaseVariables = {
  pathParams: PullEuropaceCasePathParams;
} & CoreContext["fetcherOptions"];

export const fetchPullEuropaceCase = (
  variables: PullEuropaceCaseVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    PullEuropaceCaseError,
    undefined,
    {},
    {},
    PullEuropaceCasePathParams
  >({
    url: "/hubspot/v1/crm-card/europace/{europaceCaseId}/pull",
    method: "post",
    ...variables,
    signal,
  });

export const usePullEuropaceCase = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.HubspotCardActionResponse,
      PullEuropaceCaseError,
      PullEuropaceCaseVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.HubspotCardActionResponse,
    PullEuropaceCaseError,
    PullEuropaceCaseVariables
  >({
    mutationFn: (variables: PullEuropaceCaseVariables) =>
      fetchPullEuropaceCase({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PushEuropaceCaseToBaufinexPathParams = {
  europaceCaseId: string;
};

export type PushEuropaceCaseToBaufinexError = Fetcher.ErrorWrapper<undefined>;

export type PushEuropaceCaseToBaufinexVariables = {
  pathParams: PushEuropaceCaseToBaufinexPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPushEuropaceCaseToBaufinex = (
  variables: PushEuropaceCaseToBaufinexVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    PushEuropaceCaseToBaufinexError,
    undefined,
    {},
    {},
    PushEuropaceCaseToBaufinexPathParams
  >({
    url: "/hubspot/v1/crm-card/europace/{europaceCaseId}/push/baufinex",
    method: "post",
    ...variables,
    signal,
  });

export const usePushEuropaceCaseToBaufinex = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.HubspotCardActionResponse,
      PushEuropaceCaseToBaufinexError,
      PushEuropaceCaseToBaufinexVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.HubspotCardActionResponse,
    PushEuropaceCaseToBaufinexError,
    PushEuropaceCaseToBaufinexVariables
  >({
    mutationFn: (variables: PushEuropaceCaseToBaufinexVariables) =>
      fetchPushEuropaceCaseToBaufinex({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PushEuropaceCaseToCreditwebPathParams = {
  europaceCaseId: string;
};

export type PushEuropaceCaseToCreditwebError = Fetcher.ErrorWrapper<undefined>;

export type PushEuropaceCaseToCreditwebVariables = {
  pathParams: PushEuropaceCaseToCreditwebPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPushEuropaceCaseToCreditweb = (
  variables: PushEuropaceCaseToCreditwebVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    PushEuropaceCaseToCreditwebError,
    undefined,
    {},
    {},
    PushEuropaceCaseToCreditwebPathParams
  >({
    url: "/hubspot/v1/crm-card/europace/{europaceCaseId}/push/creditweb",
    method: "post",
    ...variables,
    signal,
  });

export const usePushEuropaceCaseToCreditweb = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.HubspotCardActionResponse,
      PushEuropaceCaseToCreditwebError,
      PushEuropaceCaseToCreditwebVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.HubspotCardActionResponse,
    PushEuropaceCaseToCreditwebError,
    PushEuropaceCaseToCreditwebVariables
  >({
    mutationFn: (variables: PushEuropaceCaseToCreditwebVariables) =>
      fetchPushEuropaceCaseToCreditweb({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PushEuropaceCaseToEhypPathParams = {
  europaceCaseId: string;
};

export type PushEuropaceCaseToEhypError = Fetcher.ErrorWrapper<undefined>;

export type PushEuropaceCaseToEhypVariables = {
  pathParams: PushEuropaceCaseToEhypPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPushEuropaceCaseToEhyp = (
  variables: PushEuropaceCaseToEhypVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    PushEuropaceCaseToEhypError,
    undefined,
    {},
    {},
    PushEuropaceCaseToEhypPathParams
  >({
    url: "/hubspot/v1/crm-card/europace/{europaceCaseId}/push/ehyp",
    method: "post",
    ...variables,
    signal,
  });

export const usePushEuropaceCaseToEhyp = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.HubspotCardActionResponse,
      PushEuropaceCaseToEhypError,
      PushEuropaceCaseToEhypVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.HubspotCardActionResponse,
    PushEuropaceCaseToEhypError,
    PushEuropaceCaseToEhypVariables
  >({
    mutationFn: (variables: PushEuropaceCaseToEhypVariables) =>
      fetchPushEuropaceCaseToEhyp({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PushEuropaceCaseToForumPathParams = {
  europaceCaseId: string;
};

export type PushEuropaceCaseToForumError = Fetcher.ErrorWrapper<undefined>;

export type PushEuropaceCaseToForumVariables = {
  pathParams: PushEuropaceCaseToForumPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPushEuropaceCaseToForum = (
  variables: PushEuropaceCaseToForumVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    PushEuropaceCaseToForumError,
    undefined,
    {},
    {},
    PushEuropaceCaseToForumPathParams
  >({
    url: "/hubspot/v1/crm-card/europace/{europaceCaseId}/push/forum",
    method: "post",
    ...variables,
    signal,
  });

export const usePushEuropaceCaseToForum = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.HubspotCardActionResponse,
      PushEuropaceCaseToForumError,
      PushEuropaceCaseToForumVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.HubspotCardActionResponse,
    PushEuropaceCaseToForumError,
    PushEuropaceCaseToForumVariables
  >({
    mutationFn: (variables: PushEuropaceCaseToForumVariables) =>
      fetchPushEuropaceCaseToForum({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetFinancingCertificateCrmCardQueryParams = {
  associatedObjectId: string;
};

export type GetFinancingCertificateCrmCardError =
  Fetcher.ErrorWrapper<undefined>;

export type GetFinancingCertificateCrmCardVariables = {
  queryParams: GetFinancingCertificateCrmCardQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchGetFinancingCertificateCrmCard = (
  variables: GetFinancingCertificateCrmCardVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    GetFinancingCertificateCrmCardError,
    undefined,
    {},
    GetFinancingCertificateCrmCardQueryParams,
    {}
  >({
    url: "/hubspot/v1/crm-card/lead/certificate",
    method: "get",
    ...variables,
    signal,
  });

export const useGetFinancingCertificateCrmCard = <
  TData = Schemas.HubspotCardActionResponse,
>(
  variables: GetFinancingCertificateCrmCardVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.HubspotCardActionResponse,
      GetFinancingCertificateCrmCardError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.HubspotCardActionResponse,
    GetFinancingCertificateCrmCardError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/hubspot/v1/crm-card/lead/certificate",
      operationId: "getFinancingCertificateCrmCard",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetFinancingCertificateCrmCard(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type GetCertificateLinkQueryParams = {
  /**
   * The token for accessing a certificate
   */
  token: string;
};

export type GetCertificateLinkError = Fetcher.ErrorWrapper<undefined>;

export type GetCertificateLinkVariables = {
  queryParams: GetCertificateLinkQueryParams;
} & CoreContext["fetcherOptions"];

/**
 * Public endpoint for viewing a finance certificate
 */
export const fetchGetCertificateLink = (
  variables: GetCertificateLinkVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    GetCertificateLinkError,
    undefined,
    {},
    GetCertificateLinkQueryParams,
    {}
  >({
    url: "/hubspot/v1/public/certificate",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Public endpoint for viewing a finance certificate
 */
export const useGetCertificateLink = <TData = undefined>(
  variables: GetCertificateLinkVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetCertificateLinkError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<undefined, GetCertificateLinkError, TData>({
    queryKey: queryKeyFn({
      path: "/hubspot/v1/public/certificate",
      operationId: "getCertificateLink",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetCertificateLink({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetLeadInformationQueryParams = {
  /**
   * The object (contact in our case) ID
   */
  associatedObjectId: number;
  /**
   * The Justhome lead ID of the contact
   */
  justhome_lead_id?: string;
};

export type GetLeadInformationError = Fetcher.ErrorWrapper<undefined>;

export type GetLeadInformationVariables = {
  queryParams: GetLeadInformationQueryParams;
} & CoreContext["fetcherOptions"];

/**
 * Get lead information (captain M link for now)
 */
export const fetchGetLeadInformation = (
  variables: GetLeadInformationVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardResponse,
    GetLeadInformationError,
    undefined,
    {},
    GetLeadInformationQueryParams,
    {}
  >({ url: "/hubspot/v1/public/lead", method: "get", ...variables, signal });

/**
 * Get lead information (captain M link for now)
 */
export const useGetLeadInformation = <TData = Schemas.HubspotCardResponse>(
  variables: GetLeadInformationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.HubspotCardResponse,
      GetLeadInformationError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.HubspotCardResponse,
    GetLeadInformationError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/hubspot/v1/public/lead",
      operationId: "getLeadInformation",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetLeadInformation({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateHubspotLeadQueryParams = {
  /**
   * The contact ID out of which to create the lead.
   */
  contactId: string;
};

export type CreateHubspotLeadError = Fetcher.ErrorWrapper<undefined>;

export type CreateHubspotLeadVariables = {
  queryParams: CreateHubspotLeadQueryParams;
} & CoreContext["fetcherOptions"];

/**
 * Creates a lead out of the Hubspot contact.
 */
export const fetchCreateHubspotLead = (
  variables: CreateHubspotLeadVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    CreateHubspotLeadError,
    undefined,
    {},
    CreateHubspotLeadQueryParams,
    {}
  >({ url: "/hubspot/v1/public/lead", method: "post", ...variables, signal });

/**
 * Creates a lead out of the Hubspot contact.
 */
export const useCreateHubspotLead = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.HubspotCardActionResponse,
      CreateHubspotLeadError,
      CreateHubspotLeadVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.HubspotCardActionResponse,
    CreateHubspotLeadError,
    CreateHubspotLeadVariables
  >({
    mutationFn: (variables: CreateHubspotLeadVariables) =>
      fetchCreateHubspotLead({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteHubspotLeadQueryParams = {
  /**
   * The ID of the contact to delete
   */
  contactId: string;
  /**
   * The ID of the lead to delete.
   */
  leadId: string;
};

export type DeleteHubspotLeadError = Fetcher.ErrorWrapper<undefined>;

export type DeleteHubspotLeadVariables = {
  queryParams: DeleteHubspotLeadQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchDeleteHubspotLead = (
  variables: DeleteHubspotLeadVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    DeleteHubspotLeadError,
    undefined,
    {},
    DeleteHubspotLeadQueryParams,
    {}
  >({ url: "/hubspot/v1/public/lead", method: "delete", ...variables, signal });

export const useDeleteHubspotLead = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.HubspotCardActionResponse,
      DeleteHubspotLeadError,
      DeleteHubspotLeadVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.HubspotCardActionResponse,
    DeleteHubspotLeadError,
    DeleteHubspotLeadVariables
  >({
    mutationFn: (variables: DeleteHubspotLeadVariables) =>
      fetchDeleteHubspotLead({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetLeadActivityQueryParams = {
  /**
   * The Justhome lead ID of the contact
   */
  justhome_lead_id: string;
};

export type GetLeadActivityError = Fetcher.ErrorWrapper<undefined>;

export type GetLeadActivityVariables = {
  queryParams: GetLeadActivityQueryParams;
} & CoreContext["fetcherOptions"];

/**
 * Get lead activity
 */
export const fetchGetLeadActivity = (
  variables: GetLeadActivityVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardResponse,
    GetLeadActivityError,
    undefined,
    {},
    GetLeadActivityQueryParams,
    {}
  >({
    url: "/hubspot/v1/public/lead/activity",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Get lead activity
 */
export const useGetLeadActivity = <TData = Schemas.HubspotCardResponse>(
  variables: GetLeadActivityVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.HubspotCardResponse,
      GetLeadActivityError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.HubspotCardResponse,
    GetLeadActivityError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/hubspot/v1/public/lead/activity",
      operationId: "getLeadActivity",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetLeadActivity({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateLeadCertificateQueryParams = {
  hubspotDealId: string;
  europaceCaseId: string;
};

export type CreateLeadCertificateError = Fetcher.ErrorWrapper<undefined>;

export type CreateLeadCertificateVariables = {
  queryParams: CreateLeadCertificateQueryParams;
} & CoreContext["fetcherOptions"];

/**
 * Create a certificate for the lead
 */
export const fetchCreateLeadCertificate = (
  variables: CreateLeadCertificateVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    CreateLeadCertificateError,
    undefined,
    {},
    CreateLeadCertificateQueryParams,
    {}
  >({
    url: "/hubspot/v1/public/lead/certificate",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Create a certificate for the lead
 */
export const useCreateLeadCertificate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.HubspotCardActionResponse,
      CreateLeadCertificateError,
      CreateLeadCertificateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.HubspotCardActionResponse,
    CreateLeadCertificateError,
    CreateLeadCertificateVariables
  >({
    mutationFn: (variables: CreateLeadCertificateVariables) =>
      fetchCreateLeadCertificate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetExternalMappingsQueryParams = {
  /**
   * The deal ID
   */
  associatedObjectId: string;
  /**
   * The user email
   */
  userEmail: string;
};

export type GetExternalMappingsError = Fetcher.ErrorWrapper<undefined>;

export type GetExternalMappingsVariables = {
  queryParams: GetExternalMappingsQueryParams;
} & CoreContext["fetcherOptions"];

/**
 * Endpoint for retrieving external mappings from Europace for the deal
 */
export const fetchGetExternalMappings = (
  variables: GetExternalMappingsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardResponse,
    GetExternalMappingsError,
    undefined,
    {},
    GetExternalMappingsQueryParams,
    {}
  >({
    url: "/hubspot/v1/public/mappings",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Endpoint for retrieving external mappings from Europace for the deal
 */
export const useGetExternalMappings = <TData = Schemas.HubspotCardResponse>(
  variables: GetExternalMappingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.HubspotCardResponse,
      GetExternalMappingsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.HubspotCardResponse,
    GetExternalMappingsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/hubspot/v1/public/mappings",
      operationId: "getExternalMappings",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetExternalMappings({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetThinkImmoCrmCardQueryParams = {
  /**
   * The object (contact in our case) ID
   */
  associatedObjectId: number;
  /**
   * The Justhome lead ID of the contact
   */
  justhome_lead_id: string;
};

export type GetThinkImmoCrmCardError = Fetcher.ErrorWrapper<undefined>;

export type GetThinkImmoCrmCardVariables = {
  queryParams: GetThinkImmoCrmCardQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchGetThinkImmoCrmCard = (
  variables: GetThinkImmoCrmCardVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardResponse,
    GetThinkImmoCrmCardError,
    undefined,
    {},
    GetThinkImmoCrmCardQueryParams,
    {}
  >({
    url: "/hubspot/v1/public/thinkimmo",
    method: "get",
    ...variables,
    signal,
  });

export const useGetThinkImmoCrmCard = <TData = Schemas.HubspotCardResponse>(
  variables: GetThinkImmoCrmCardVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.HubspotCardResponse,
      GetThinkImmoCrmCardError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.HubspotCardResponse,
    GetThinkImmoCrmCardError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/hubspot/v1/public/thinkimmo",
      operationId: "getThinkImmoCrmCard",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetThinkImmoCrmCard({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ExportLeadToThinkImmoQueryParams = {
  /**
   * The ID of the contact to export to ThinkImmo.
   */
  contactId: string;
  /**
   * The ID of the lead corresponding to the contact
   */
  leadId: string;
};

export type ExportLeadToThinkImmoError = Fetcher.ErrorWrapper<undefined>;

export type ExportLeadToThinkImmoVariables = {
  queryParams: ExportLeadToThinkImmoQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchExportLeadToThinkImmo = (
  variables: ExportLeadToThinkImmoVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.HubspotCardActionResponse,
    ExportLeadToThinkImmoError,
    undefined,
    {},
    ExportLeadToThinkImmoQueryParams,
    {}
  >({
    url: "/hubspot/v1/public/thinkimmo",
    method: "post",
    ...variables,
    signal,
  });

export const useExportLeadToThinkImmo = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.HubspotCardActionResponse,
      ExportLeadToThinkImmoError,
      ExportLeadToThinkImmoVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.HubspotCardActionResponse,
    ExportLeadToThinkImmoError,
    ExportLeadToThinkImmoVariables
  >({
    mutationFn: (variables: ExportLeadToThinkImmoVariables) =>
      fetchExportLeadToThinkImmo({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteThinkImmoAlertPathParams = {
  alertId: string;
};

export type DeleteThinkImmoAlertQueryParams = {
  /**
   * The ID of the lead
   */
  leadId: string;
};

export type DeleteThinkImmoAlertError = Fetcher.ErrorWrapper<undefined>;

export type DeleteThinkImmoAlertVariables = {
  pathParams: DeleteThinkImmoAlertPathParams;
  queryParams: DeleteThinkImmoAlertQueryParams;
} & CoreContext["fetcherOptions"];

export const fetchDeleteThinkImmoAlert = (
  variables: DeleteThinkImmoAlertVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    DeleteThinkImmoAlertError,
    undefined,
    {},
    DeleteThinkImmoAlertQueryParams,
    DeleteThinkImmoAlertPathParams
  >({
    url: "/hubspot/v1/public/thinkimmo/alert/{alertId}",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteThinkImmoAlert = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteThinkImmoAlertError,
      DeleteThinkImmoAlertVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    DeleteThinkImmoAlertError,
    DeleteThinkImmoAlertVariables
  >({
    mutationFn: (variables: DeleteThinkImmoAlertVariables) =>
      fetchDeleteThinkImmoAlert({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type HubspotWebhookCallbackError = Fetcher.ErrorWrapper<undefined>;

export type HubspotWebhookCallbackVariables = {
  body?: Schemas.HubspotWebhookPayload;
} & CoreContext["fetcherOptions"];

/**
 * The endpoint where HubSpot webhook sends the payload
 */
export const fetchHubspotWebhookCallback = (
  variables: HubspotWebhookCallbackVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    HubspotWebhookCallbackError,
    Schemas.HubspotWebhookPayload,
    {},
    {},
    {}
  >({
    url: "/hubspot/v1/public/webhook",
    method: "post",
    ...variables,
    signal,
  });

/**
 * The endpoint where HubSpot webhook sends the payload
 */
export const useHubspotWebhookCallback = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      HubspotWebhookCallbackError,
      HubspotWebhookCallbackVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    HubspotWebhookCallbackError,
    HubspotWebhookCallbackVariables
  >({
    mutationFn: (variables: HubspotWebhookCallbackVariables) =>
      fetchHubspotWebhookCallback({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetKeycloakPartnerPathParams = {
  onOfficeId: string;
  onOfficeUserId: string;
};

export type GetKeycloakPartnerError = Fetcher.ErrorWrapper<undefined>;

export type GetKeycloakPartnerVariables = {
  pathParams: GetKeycloakPartnerPathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetKeycloakPartner = (
  variables: GetKeycloakPartnerVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.KeycloakPartner,
    GetKeycloakPartnerError,
    undefined,
    {},
    {},
    GetKeycloakPartnerPathParams
  >({
    url: "/keycloak/partner/{onOfficeId}/user/{onOfficeUserId}",
    method: "get",
    ...variables,
    signal,
  });

export const useGetKeycloakPartner = <TData = Schemas.KeycloakPartner>(
  variables: GetKeycloakPartnerVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.KeycloakPartner,
      GetKeycloakPartnerError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    Schemas.KeycloakPartner,
    GetKeycloakPartnerError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/keycloak/partner/{onOfficeId}/user/{onOfficeUserId}",
      operationId: "getKeycloakPartner",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetKeycloakPartner({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type UpsertKeycloakUserPathParams = {
  keycloakUserId: string;
};

export type UpsertKeycloakUserError = Fetcher.ErrorWrapper<undefined>;

export type UpsertKeycloakUserVariables = {
  body: Schemas.UpsertKeycloakUser;
  pathParams: UpsertKeycloakUserPathParams;
} & CoreContext["fetcherOptions"];

export const fetchUpsertKeycloakUser = (
  variables: UpsertKeycloakUserVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    UpsertKeycloakUserError,
    Schemas.UpsertKeycloakUser,
    {},
    {},
    UpsertKeycloakUserPathParams
  >({
    url: "/keycloak/users/{keycloakUserId}",
    method: "post",
    ...variables,
    signal,
  });

export const useUpsertKeycloakUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpsertKeycloakUserError,
      UpsertKeycloakUserVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    UpsertKeycloakUserError,
    UpsertKeycloakUserVariables
  >({
    mutationFn: (variables: UpsertKeycloakUserVariables) =>
      fetchUpsertKeycloakUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostMsgraphWebhookError = Fetcher.ErrorWrapper<undefined>;

export type PostMsgraphWebhookRequestBody = {
  [key: string]: any;
};

export type PostMsgraphWebhookVariables = {
  body?: PostMsgraphWebhookRequestBody;
} & CoreContext["fetcherOptions"];

export const fetchPostMsgraphWebhook = (
  variables: PostMsgraphWebhookVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostMsgraphWebhookError,
    PostMsgraphWebhookRequestBody,
    {},
    {},
    {}
  >({ url: "/msgraph/webhook", method: "post", ...variables, signal });

export const usePostMsgraphWebhook = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostMsgraphWebhookError,
      PostMsgraphWebhookVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostMsgraphWebhookError,
    PostMsgraphWebhookVariables
  >({
    mutationFn: (variables: PostMsgraphWebhookVariables) =>
      fetchPostMsgraphWebhook({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostPropstackClientPropertyCreatedWebhookPathParams = {
  partnerId: string;
};

export type PostPropstackClientPropertyCreatedWebhookError =
  Fetcher.ErrorWrapper<undefined>;

export type PostPropstackClientPropertyCreatedWebhookVariables = {
  pathParams: PostPropstackClientPropertyCreatedWebhookPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostPropstackClientPropertyCreatedWebhook = (
  variables: PostPropstackClientPropertyCreatedWebhookVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostPropstackClientPropertyCreatedWebhookError,
    undefined,
    {},
    {},
    PostPropstackClientPropertyCreatedWebhookPathParams
  >({
    url: "/propstack/v1/public/partners/{partnerId}/webhook/client-property-created",
    method: "post",
    ...variables,
    signal,
  });

export const usePostPropstackClientPropertyCreatedWebhook = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostPropstackClientPropertyCreatedWebhookError,
      PostPropstackClientPropertyCreatedWebhookVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostPropstackClientPropertyCreatedWebhookError,
    PostPropstackClientPropertyCreatedWebhookVariables
  >({
    mutationFn: (
      variables: PostPropstackClientPropertyCreatedWebhookVariables,
    ) =>
      fetchPostPropstackClientPropertyCreatedWebhook({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type PostPropstackClientPropertyUpdatedWebhookPathParams = {
  partnerId: string;
};

export type PostPropstackClientPropertyUpdatedWebhookError =
  Fetcher.ErrorWrapper<undefined>;

export type PostPropstackClientPropertyUpdatedWebhookVariables = {
  pathParams: PostPropstackClientPropertyUpdatedWebhookPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostPropstackClientPropertyUpdatedWebhook = (
  variables: PostPropstackClientPropertyUpdatedWebhookVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostPropstackClientPropertyUpdatedWebhookError,
    undefined,
    {},
    {},
    PostPropstackClientPropertyUpdatedWebhookPathParams
  >({
    url: "/propstack/v1/public/partners/{partnerId}/webhook/client-property-updated",
    method: "post",
    ...variables,
    signal,
  });

export const usePostPropstackClientPropertyUpdatedWebhook = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostPropstackClientPropertyUpdatedWebhookError,
      PostPropstackClientPropertyUpdatedWebhookVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostPropstackClientPropertyUpdatedWebhookError,
    PostPropstackClientPropertyUpdatedWebhookVariables
  >({
    mutationFn: (
      variables: PostPropstackClientPropertyUpdatedWebhookVariables,
    ) =>
      fetchPostPropstackClientPropertyUpdatedWebhook({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type PostPropstackClientUpdatedWebhookPathParams = {
  partnerId: string;
};

export type PostPropstackClientUpdatedWebhookError =
  Fetcher.ErrorWrapper<undefined>;

export type PostPropstackClientUpdatedWebhookVariables = {
  pathParams: PostPropstackClientUpdatedWebhookPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostPropstackClientUpdatedWebhook = (
  variables: PostPropstackClientUpdatedWebhookVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostPropstackClientUpdatedWebhookError,
    undefined,
    {},
    {},
    PostPropstackClientUpdatedWebhookPathParams
  >({
    url: "/propstack/v1/public/partners/{partnerId}/webhook/client-updated",
    method: "post",
    ...variables,
    signal,
  });

export const usePostPropstackClientUpdatedWebhook = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostPropstackClientUpdatedWebhookError,
      PostPropstackClientUpdatedWebhookVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostPropstackClientUpdatedWebhookError,
    PostPropstackClientUpdatedWebhookVariables
  >({
    mutationFn: (variables: PostPropstackClientUpdatedWebhookVariables) =>
      fetchPostPropstackClientUpdatedWebhook({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type PostPropstackPropertyUpdatedWebhookPathParams = {
  partnerId: string;
};

export type PostPropstackPropertyUpdatedWebhookError =
  Fetcher.ErrorWrapper<undefined>;

export type PostPropstackPropertyUpdatedWebhookVariables = {
  pathParams: PostPropstackPropertyUpdatedWebhookPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostPropstackPropertyUpdatedWebhook = (
  variables: PostPropstackPropertyUpdatedWebhookVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostPropstackPropertyUpdatedWebhookError,
    undefined,
    {},
    {},
    PostPropstackPropertyUpdatedWebhookPathParams
  >({
    url: "/propstack/v1/public/partners/{partnerId}/webhook/property-updated",
    method: "post",
    ...variables,
    signal,
  });

export const usePostPropstackPropertyUpdatedWebhook = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostPropstackPropertyUpdatedWebhookError,
      PostPropstackPropertyUpdatedWebhookVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostPropstackPropertyUpdatedWebhookError,
    PostPropstackPropertyUpdatedWebhookVariables
  >({
    mutationFn: (variables: PostPropstackPropertyUpdatedWebhookVariables) =>
      fetchPostPropstackPropertyUpdatedWebhook({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type GetSmsTemplatesError = Fetcher.ErrorWrapper<undefined>;

export type GetSmsTemplatesResponse = Schemas.SMSTemplate[];

export type GetSmsTemplatesVariables = CoreContext["fetcherOptions"];

export const fetchGetSmsTemplates = (
  variables: GetSmsTemplatesVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    GetSmsTemplatesResponse,
    GetSmsTemplatesError,
    undefined,
    {},
    {},
    {}
  >({ url: "/sms/v1/templates", method: "get", ...variables, signal });

export const useGetSmsTemplates = <TData = GetSmsTemplatesResponse>(
  variables: GetSmsTemplatesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetSmsTemplatesResponse,
      GetSmsTemplatesError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<
    GetSmsTemplatesResponse,
    GetSmsTemplatesError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/sms/v1/templates",
      operationId: "getSmsTemplates",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetSmsTemplates({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type PostSmsTemplateError = Fetcher.ErrorWrapper<undefined>;

export type PostSmsTemplateVariables = {
  body: Schemas.SMSTemplate;
} & CoreContext["fetcherOptions"];

export const fetchPostSmsTemplate = (
  variables: PostSmsTemplateVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.SMSTemplate,
    PostSmsTemplateError,
    Schemas.SMSTemplate,
    {},
    {},
    {}
  >({ url: "/sms/v1/templates", method: "post", ...variables, signal });

export const usePostSmsTemplate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SMSTemplate,
      PostSmsTemplateError,
      PostSmsTemplateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.SMSTemplate,
    PostSmsTemplateError,
    PostSmsTemplateVariables
  >({
    mutationFn: (variables: PostSmsTemplateVariables) =>
      fetchPostSmsTemplate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetSmsTemplatePathParams = {
  id: string;
};

export type GetSmsTemplateError = Fetcher.ErrorWrapper<undefined>;

export type GetSmsTemplateVariables = {
  pathParams: GetSmsTemplatePathParams;
} & CoreContext["fetcherOptions"];

export const fetchGetSmsTemplate = (
  variables: GetSmsTemplateVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.SMSTemplate,
    GetSmsTemplateError,
    undefined,
    {},
    {},
    GetSmsTemplatePathParams
  >({ url: "/sms/v1/templates/{id}", method: "get", ...variables, signal });

export const useGetSmsTemplate = <TData = Schemas.SMSTemplate>(
  variables: GetSmsTemplateVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SMSTemplate, GetSmsTemplateError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCoreContext(options);
  return reactQuery.useQuery<Schemas.SMSTemplate, GetSmsTemplateError, TData>({
    queryKey: queryKeyFn({
      path: "/sms/v1/templates/{id}",
      operationId: "getSmsTemplate",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetSmsTemplate({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type DeleteSmsTemplatePathParams = {
  id: string;
};

export type DeleteSmsTemplateError = Fetcher.ErrorWrapper<undefined>;

export type DeleteSmsTemplateVariables = {
  pathParams: DeleteSmsTemplatePathParams;
} & CoreContext["fetcherOptions"];

export const fetchDeleteSmsTemplate = (
  variables: DeleteSmsTemplateVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    DeleteSmsTemplateError,
    undefined,
    {},
    {},
    DeleteSmsTemplatePathParams
  >({ url: "/sms/v1/templates/{id}", method: "delete", ...variables, signal });

export const useDeleteSmsTemplate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteSmsTemplateError,
      DeleteSmsTemplateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    DeleteSmsTemplateError,
    DeleteSmsTemplateVariables
  >({
    mutationFn: (variables: DeleteSmsTemplateVariables) =>
      fetchDeleteSmsTemplate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateSmsTemplatePathParams = {
  id: string;
};

export type UpdateSmsTemplateError = Fetcher.ErrorWrapper<undefined>;

export type UpdateSmsTemplateVariables = {
  body: Schemas.SMSTemplate;
  pathParams: UpdateSmsTemplatePathParams;
} & CoreContext["fetcherOptions"];

export const fetchUpdateSmsTemplate = (
  variables: UpdateSmsTemplateVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    Schemas.SMSTemplate,
    UpdateSmsTemplateError,
    Schemas.SMSTemplate,
    {},
    {},
    UpdateSmsTemplatePathParams
  >({ url: "/sms/v1/templates/{id}", method: "patch", ...variables, signal });

export const useUpdateSmsTemplate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SMSTemplate,
      UpdateSmsTemplateError,
      UpdateSmsTemplateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    Schemas.SMSTemplate,
    UpdateSmsTemplateError,
    UpdateSmsTemplateVariables
  >({
    mutationFn: (variables: UpdateSmsTemplateVariables) =>
      fetchUpdateSmsTemplate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostZapierDocumentsPathParams = {
  europaceCaseId: string;
};

export type PostZapierDocumentsError = Fetcher.ErrorWrapper<undefined>;

export type PostZapierDocumentsVariables = {
  pathParams: PostZapierDocumentsPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostZapierDocuments = (
  variables: PostZapierDocumentsVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostZapierDocumentsError,
    undefined,
    {},
    {},
    PostZapierDocumentsPathParams
  >({
    url: "/zapier/v1/documents/{europaceCaseId}",
    method: "post",
    ...variables,
    signal,
  });

export const usePostZapierDocuments = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostZapierDocumentsError,
      PostZapierDocumentsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostZapierDocumentsError,
    PostZapierDocumentsVariables
  >({
    mutationFn: (variables: PostZapierDocumentsVariables) =>
      fetchPostZapierDocuments({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateImmoscoutLeadPathParams = {
  /**
   * The immoscout ID
   */
  id: number;
};

export type CreateImmoscoutLeadError = Fetcher.ErrorWrapper<undefined>;

export type CreateImmoscoutLeadVariables = {
  body: Schemas.ImmoscoutLeadRequest;
  pathParams: CreateImmoscoutLeadPathParams;
} & CoreContext["fetcherOptions"];

export const fetchCreateImmoscoutLead = (
  variables: CreateImmoscoutLeadVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    CreateImmoscoutLeadError,
    Schemas.ImmoscoutLeadRequest,
    {},
    {},
    CreateImmoscoutLeadPathParams
  >({
    url: "/zapier/v1/lead/immoscout/{id}",
    method: "post",
    ...variables,
    signal,
  });

export const useCreateImmoscoutLead = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      CreateImmoscoutLeadError,
      CreateImmoscoutLeadVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    CreateImmoscoutLeadError,
    CreateImmoscoutLeadVariables
  >({
    mutationFn: (variables: CreateImmoscoutLeadVariables) =>
      fetchCreateImmoscoutLead({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateImmoweltLeadError = Fetcher.ErrorWrapper<undefined>;

export type CreateImmoweltLeadVariables = CoreContext["fetcherOptions"];

export const fetchCreateImmoweltLead = (
  variables: CreateImmoweltLeadVariables,
  signal?: AbortSignal,
) =>
  coreFetch<undefined, CreateImmoweltLeadError, undefined, {}, {}, {}>({
    url: "/zapier/v1/lead/immowelt",
    method: "post",
    ...variables,
    signal,
  });

export const useCreateImmoweltLead = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      CreateImmoweltLeadError,
      CreateImmoweltLeadVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    CreateImmoweltLeadError,
    CreateImmoweltLeadVariables
  >({
    mutationFn: (variables: CreateImmoweltLeadVariables) =>
      fetchCreateImmoweltLead({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateVergleichLeadPathParams = {
  /**
   * The ID of the vergleich lead
   */
  id: string;
};

export type CreateVergleichLeadError = Fetcher.ErrorWrapper<undefined>;

export type CreateVergleichLeadVariables = {
  pathParams: CreateVergleichLeadPathParams;
} & CoreContext["fetcherOptions"];

export const fetchCreateVergleichLead = (
  variables: CreateVergleichLeadVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    CreateVergleichLeadError,
    undefined,
    {},
    {},
    CreateVergleichLeadPathParams
  >({
    url: "/zapier/v1/lead/vergleich/{id}",
    method: "post",
    ...variables,
    signal,
  });

export const useCreateVergleichLead = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      CreateVergleichLeadError,
      CreateVergleichLeadVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    CreateVergleichLeadError,
    CreateVergleichLeadVariables
  >({
    mutationFn: (variables: CreateVergleichLeadVariables) =>
      fetchCreateVergleichLead({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostMeetingReminderError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ErrorResponse;
}>;

export type PostMeetingReminderVariables = {
  body: Schemas.MeetingReminder;
} & CoreContext["fetcherOptions"];

export const fetchPostMeetingReminder = (
  variables: PostMeetingReminderVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostMeetingReminderError,
    Schemas.MeetingReminder,
    {},
    {},
    {}
  >({
    url: "/zapier/v1/meeting-reminder",
    method: "post",
    ...variables,
    signal,
  });

export const usePostMeetingReminder = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostMeetingReminderError,
      PostMeetingReminderVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostMeetingReminderError,
    PostMeetingReminderVariables
  >({
    mutationFn: (variables: PostMeetingReminderVariables) =>
      fetchPostMeetingReminder({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostObaReminderError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ErrorResponse;
}>;

export type PostObaReminderVariables = {
  body: Schemas.OBAReminder;
} & CoreContext["fetcherOptions"];

export const fetchPostObaReminder = (
  variables: PostObaReminderVariables,
  signal?: AbortSignal,
) =>
  coreFetch<undefined, PostObaReminderError, Schemas.OBAReminder, {}, {}, {}>({
    url: "/zapier/v1/oba-reminder",
    method: "post",
    ...variables,
    signal,
  });

export const usePostObaReminder = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostObaReminderError,
      PostObaReminderVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostObaReminderError,
    PostObaReminderVariables
  >({
    mutationFn: (variables: PostObaReminderVariables) =>
      fetchPostObaReminder({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PostThinkImmoNotificationPathParams = {
  thinkImmoId: string;
};

export type PostThinkImmoNotificationError = Fetcher.ErrorWrapper<undefined>;

export type PostThinkImmoNotificationVariables = {
  pathParams: PostThinkImmoNotificationPathParams;
} & CoreContext["fetcherOptions"];

export const fetchPostThinkImmoNotification = (
  variables: PostThinkImmoNotificationVariables,
  signal?: AbortSignal,
) =>
  coreFetch<
    undefined,
    PostThinkImmoNotificationError,
    undefined,
    {},
    {},
    PostThinkImmoNotificationPathParams
  >({
    url: "/zapier/v1/thinkimmo/{thinkImmoId}",
    method: "post",
    ...variables,
    signal,
  });

export const usePostThinkImmoNotification = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PostThinkImmoNotificationError,
      PostThinkImmoNotificationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCoreContext();
  return reactQuery.useMutation<
    undefined,
    PostThinkImmoNotificationError,
    PostThinkImmoNotificationVariables
  >({
    mutationFn: (variables: PostThinkImmoNotificationVariables) =>
      fetchPostThinkImmoNotification({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type QueryOperation =
  | {
      path: "/advisors";
      operationId: "getAdvisors";
      variables: GetAdvisorsVariables;
    }
  | {
      path: "/advisors/{advisorId}/meetings";
      operationId: "getAdvisorMeetings";
      variables: GetAdvisorMeetingsVariables;
    }
  | {
      path: "/gateway/v1/aircall/redirect";
      operationId: "getAircallRedirect";
      variables: GetAircallRedirectVariables;
    }
  | {
      path: "/gateway/v1/application/{applicationId}";
      operationId: "getApplicationResults";
      variables: GetApplicationResultsVariables;
    }
  | {
      path: "/gateway/v1/applications/{applicationId}/advisor-calendar";
      operationId: "getAdvisorCalendar";
      variables: GetAdvisorCalendarVariables;
    }
  | {
      path: "/gateway/v1/assumption";
      operationId: "getAssumptions";
      variables: GetAssumptionsVariables;
    }
  | {
      path: "/gateway/v1/certificate/{token}";
      operationId: "getCertificateByToken";
      variables: GetCertificateByTokenVariables;
    }
  | {
      path: "/gateway/v1/frontend-state/{id}";
      operationId: "getFrontendState";
      variables: GetFrontendStateVariables;
    }
  | {
      path: "/gateway/v1/lead/share-medal-rating";
      operationId: "shareMedalRatingEmail";
      variables: ShareMedalRatingEmailVariables;
    }
  | {
      path: "/gateway/v1/partner/onoffice/{webCustomerId}";
      operationId: "getPartnerByOnofficeWebCustomerId";
      variables: GetPartnerByOnofficeWebCustomerIdVariables;
    }
  | {
      path: "/gateway/v1/partner/propstack/{companyId}/";
      operationId: "getPartnerByPropstackCompanyId";
      variables: GetPartnerByPropstackCompanyIdVariables;
    }
  | {
      path: "/gateway/v1/partner/{id}";
      operationId: "getPartner";
      variables: GetPartnerVariables;
    }
  | {
      path: "/gateway/v1/partner/{partnerId}/property/{propertyId}";
      operationId: "getPartnerProperty";
      variables: GetPartnerPropertyVariables;
    }
  | {
      path: "/gateway/v1/projects/{projectId}/meeting-nps";
      operationId: "saveFirstMeetingNps";
      variables: SaveFirstMeetingNpsVariables;
    }
  | {
      path: "/gateway/v1/saved-offers-pdf/{token}";
      operationId: "getSavedOffersPdfByToken";
      variables: GetSavedOffersPdfByTokenVariables;
    }
  | {
      path: "/interest-rates";
      operationId: "getInterestRateChart";
      variables: GetInterestRateChartVariables;
    }
  | {
      path: "/advisor/me";
      operationId: "getAdvisor";
      variables: GetAdvisorVariables;
    }
  | {
      path: "/advisor/document-list-presets";
      operationId: "getAdvisorDocumentListPresets";
      variables: GetAdvisorDocumentListPresetsVariables;
    }
  | {
      path: "/advisor/document-list-presets/{documentListPresetId}";
      operationId: "getAdvisorDocumentListPreset";
      variables: GetAdvisorDocumentListPresetVariables;
    }
  | {
      path: "/advisor/document-types";
      operationId: "getAdvisorDocumentTypes";
      variables: GetAdvisorDocumentTypesVariables;
    }
  | {
      path: "/advisor/events";
      operationId: "getAdvisorEvents";
      variables: GetAdvisorEventsVariables;
    }
  | {
      path: "/advisor/images";
      operationId: "advisorGetImage";
      variables: AdvisorGetImageVariables;
    }
  | {
      path: "/advisor/leads/{leadId}";
      operationId: "getAdvisorLead";
      variables: GetAdvisorLeadVariables;
    }
  | {
      path: "/advisor/leads/{leadId}/projects/{projectId}";
      operationId: "getAdvisorProject";
      variables: GetAdvisorProjectVariables;
    }
  | {
      path: "/advisor/leads/{leadId}/projects/{projectId}/crm-property";
      operationId: "getAdvisorCrmProperty";
      variables: GetAdvisorCrmPropertyVariables;
    }
  | {
      path: "/advisor/leads/{leadId}/projects/{projectId}/document-groups";
      operationId: "getAdvisorDocumentGroups";
      variables: GetAdvisorDocumentGroupsVariables;
    }
  | {
      path: "/advisor/leads/{leadId}/projects/{projectId}/document-lists";
      operationId: "getAdvisorDocumentLists";
      variables: GetAdvisorDocumentListsVariables;
    }
  | {
      path: "/advisor/leads/{leadId}/projects/{projectId}/download-files";
      operationId: "advisorDownloadFiles";
      variables: AdvisorDownloadFilesVariables;
    }
  | {
      path: "/advisor/leads/{leadId}/projects/{projectId}/import";
      operationId: "getUnimportedAdvisorDocuments";
      variables: GetUnimportedAdvisorDocumentsVariables;
    }
  | {
      path: "/advisor/leads/{leadId}/projects/{projectId}/related-projects";
      operationId: "getAdvisorProjectRelatedProjects";
      variables: GetAdvisorProjectRelatedProjectsVariables;
    }
  | {
      path: "/advisor/partners/{partnerId}";
      operationId: "getAdvisorPartner";
      variables: GetAdvisorPartnerVariables;
    }
  | {
      path: "/advisor/partners/{partnerId}/document-settings";
      operationId: "advisorGetPartnerDocumentSettings";
      variables: AdvisorGetPartnerDocumentSettingsVariables;
    }
  | {
      path: "/advisor/projects/search";
      operationId: "getAdvisorSearchProjects";
      variables: GetAdvisorSearchProjectsVariables;
    }
  | {
      path: "/advisor/projects/{projectId}/comments";
      operationId: "advisorGetCommentsByProjectId";
      variables: AdvisorGetCommentsByProjectIdVariables;
    }
  | {
      path: "/advisor/leads/{leadId}/projects/{projectId}/search";
      operationId: "advisorSearchDocuments";
      variables: AdvisorSearchDocumentsVariables;
    }
  | {
      path: "/app/assistant-chats/{chatId}";
      operationId: "getAssistantChat";
      variables: GetAssistantChatVariables;
    }
  | {
      path: "/app/document-types";
      operationId: "getAppDocumentTypes";
      variables: GetAppDocumentTypesVariables;
    }
  | {
      path: "/app/lead";
      operationId: "getEnhancedLead";
      variables: GetEnhancedLeadVariables;
    }
  | {
      path: "/app/projects/{projectId}/comments";
      operationId: "getComments";
      variables: GetCommentsVariables;
    }
  | {
      path: "/app/projects/{projectId}/document-lists";
      operationId: "getAppDocumentLists";
      variables: GetAppDocumentListsVariables;
    }
  | {
      path: "/app/projects/{projectId}/documents";
      operationId: "getDocuments";
      variables: GetDocumentsVariables;
    }
  | {
      path: "/app/projects/{projectId}/financing-certificate";
      operationId: "getAppFinancingCertificate";
      variables: GetAppFinancingCertificateVariables;
    }
  | {
      path: "/app/projects/{projectId}/offer-documents";
      operationId: "getAppOfferDocuments";
      variables: GetAppOfferDocumentsVariables;
    }
  | {
      path: "/app/projects/{projectId}/saved-offers";
      operationId: "getAppSavedOffers";
      variables: GetAppSavedOffersVariables;
    }
  | {
      path: "/hubspot/v1/crm-card/documents";
      operationId: "getDocumentsCrmCard";
      variables: GetDocumentsCrmCardVariables;
    }
  | {
      path: "/hubspot/v1/crm-card/lead/certificate";
      operationId: "getFinancingCertificateCrmCard";
      variables: GetFinancingCertificateCrmCardVariables;
    }
  | {
      path: "/hubspot/v1/public/certificate";
      operationId: "getCertificateLink";
      variables: GetCertificateLinkVariables;
    }
  | {
      path: "/hubspot/v1/public/lead";
      operationId: "getLeadInformation";
      variables: GetLeadInformationVariables;
    }
  | {
      path: "/hubspot/v1/public/lead/activity";
      operationId: "getLeadActivity";
      variables: GetLeadActivityVariables;
    }
  | {
      path: "/hubspot/v1/public/mappings";
      operationId: "getExternalMappings";
      variables: GetExternalMappingsVariables;
    }
  | {
      path: "/hubspot/v1/public/thinkimmo";
      operationId: "getThinkImmoCrmCard";
      variables: GetThinkImmoCrmCardVariables;
    }
  | {
      path: "/keycloak/partner/{onOfficeId}/user/{onOfficeUserId}";
      operationId: "getKeycloakPartner";
      variables: GetKeycloakPartnerVariables;
    }
  | {
      path: "/sms/v1/templates";
      operationId: "getSmsTemplates";
      variables: GetSmsTemplatesVariables;
    }
  | {
      path: "/sms/v1/templates/{id}";
      operationId: "getSmsTemplate";
      variables: GetSmsTemplateVariables;
    };
